<template>
    <section class="resproxy account" style="position: static;" id="vuerewriteapi">
        <div class="tab-cont ">
            <!-- top -->
            <div class="useproxy-top-select-box useproxy-balance-banner">
                <div class="useproxy-top-basic-info-box">
                    <div class="useproxy-detail-box title-box active" v-cloak>
                        <div class="useproxy-detail-box-left title-box-left">
                            <div class="title-box-left-main">
                                <div class="useproxy-detail-tit title-box-left-tit">{{ $t('use_proxy.detail.title') }}</div>
                                <div class="useproxy-detail-info title-box-left-tip">
                                    <span v-cloak>{{ displayUserTrafficBalance }}</span>
                                    <span class="useproxy-detail-time data" v-show="userTrafficExpireTime">
                                        <span class="useproxy-detail-time-name">{{ $t('use_proxy.detail.expiry_time') }}</span>
                                        <span class="useproxy-detail-time-info">
                                            <span v-cloak>{{ userTrafficExpireTime }}</span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="useproxy-detail-box-right title-box-right">
                            <div class="btn"><a href="../residential/">{{ $t('use_proxy.detail.action') }}</a></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- start -->
            <div class="form-box">
                <div class="form-left">{{ $t('use_proxy.generator.title') }}</div>
                <div class="form-right">
                    <el-form ref="form" :inline="true" class="demo-form-inline">
                        <el-form-item :label="fields.country" class="f1 act">
                            <el-select ref="selectGlobal" v-model="country" :placeholder="fields.countryph"
                                @change="changeArea" filterable clearable>

                                <el-option v-for="(item, index) in allCountryList" :key="index"
                                    :label="item.country_name" :value="item.country_code" :hostreg="item.country_code">
                                    <span class="m" v-if="item.country_code !== ''">
                                        <img :src="getImgUrl(item.country_code)" width="20px" height="20px" alt=""
                                            class="inline-block" />
                                    </span>
                                    <span class="m" v-else>
                                        <img src="@/assets/index/img/ucenter/api/area/t_qq.png" width="20px"
                                            height="20px" alt="" />
                                    </span>
                                    <span class="n" v-cloak>&ensp;{{ item.country_name }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item :label="fields.state" class="f2 act z_f2">
                            <el-select v-model="state" :placeholder="fields.stateph" @change="changeState"
                                filterable clearable>
                                <el-option v-for="(item, index) in stateOptions" :key="index" :label="item.state"
                                    :value="item.state">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <!-- <el-form-item class="a_down">
                            <a :href="regionsUrl" download="regions_en.xlsx">{{ $t('use_proxy.generator.form.download_region') }}</a>
                        </el-form-item> -->

                        <el-form-item :label="fields.rotation" class="act f6"
                            :class="rotation == 'timeip' ? 'show-time f6' : 'hide-time f6'"><el-select
                                v-model="rotation" :placeholder="fields.rotationph" @change="changeRotation">
                                <el-option v-for="(item, index) in rotationOptions" :key="index" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fields.duration" class="act f7"
                            :class="rotation == 'timeip' ? 'show-time f7' : 'hide-time f7'">
                            <el-input :placeholder="fields.duration" type="number" v-model="ipDuration" :max="30"
                                :min="1" @keyup.native="dropDown">
                            </el-input>
                            <span @click="incrementDuration" @mousedown="incrementDurationHoldOn()" @mouseup="incrementDurationRelease()"
                                @mouseleave="incrementDurationRelease()">
                                <i class="el-select__caret el-input__icon el-icon-arrow-up"></i>
                            </span>
                            <span @click="reduceDuration" @mousedown="reduceDurationHoldOn()" @mouseup="reduceDurationRelease()"
                                @mouseleave="reduceDurationRelease()">
                                <i class="el-select__caret el-input__icon el-icon-arrow-down"></i>
                            </span>
                        </el-form-item>


                        <el-form-item :label="fields.host" :class="{'act f8': formActive.host, 'f8': !formActive.host}">
                            <el-select 
                                v-model="preferHost" 
                                :placeholder="fields.host" 
                                @change="changeHost" 
                                @mousedown="onCloseOption($event)"
                            >
                                <el-option 
                                    v-for="item in proxyDomainOptions" 
                                    :key="item.address + ':' + item.port" 
                                    :label="item.address + ':' + item.port" 
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item :label="fields.username" :class="formActive.username ? 'act f9' : 'f9'">
                            <el-input :placeholder="fields.username" v-model="username" readonly
                                @click.native="onCloseOption($event)"></el-input>
                        </el-form-item>

                        <el-form-item :label="fields.password" :class="formActive.password ? 'act f10' : 'f10'">
                            <el-input :placeholder="fields.password" v-model="password" readonly></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

            <div class="link-box">
                <div class="link-box-left">{{ $t('use_proxy.generator.link.title') }}</div>
                <div class="link-box-right">
                    <el-form ref="linkform" :inline="true" class="link-form-inline">
                        <!-- <el-form-item label="Click the button above to generate API links" :class="proxyScripts ? 'act' : ''"> -->
                        <el-form-item class="link-form-input">
                            <el-input :placeholder="$t('use_proxy.generator.link.placeholder')" id="api_link_sub"
                                v-model="proxyScripts" readonly></el-input>
                        </el-form-item>

                        <el-form-item class="link-form-btn">
                            <button type="button" class="copy-link-btn" @click="copyLink('api_link_sub')">{{ $t('use_proxy.generator.link.copy') }}</button>
                        </el-form-item>

                        <el-form-item :label="fields.format" class="act rightmg">
                            <el-select v-model="accountFormatType" @change="changeAccountFormat" class="accountFormatType">
                                <el-option label="USERNAME:PASSWORD:HOST:PORT" value="1"></el-option>
                                <el-option label="HOST:PORT:USERNAME:PASSWORD" value="2"></el-option>
                                <el-option label="USERNAME:PASSWORD@HOST:PORT" value="3"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item :label="fields.quantity" class="act numinp">
                            <el-input :placeholder="fields.quantity" type="number" v-model="ipQuantity" :max="1000"
                                :min="1" @keyup.native="changeIpQuantity">
                            </el-input>
                            <span class="first" @click="incrementQuantity">
                                <i class="el-select__caret el-input__icon el-icon-arrow-up"></i>
                            </span>
                            <span class="last" @click="reduceQuantity">
                                <i class="el-select__caret el-input__icon el-icon-arrow-down"></i>
                            </span>
                        </el-form-item>

                        <el-form-item :label="fields.format" class="links">
                            <textarea name="" cols="65" rows="8" v-html="accounts" id="links"></textarea>
                        </el-form-item>

                        <el-form-item class="btn">
                            <button type="button" class="btn-btn" @click="morelist">{{ $t('use_proxy.generator.batch.title') }}</button>
                        </el-form-item>

                        <el-form-item class="btn">
                            <button type="button" class="btn-btn" @click="copyLink('links')">{{ $t('use_proxy.generator.batch.copy') }}</button>
                        </el-form-item>
<!-- 
                        <el-form-item class="link-form-instructions">
                            <div class="item-title">{{ $t('use_proxy.generator.instructions.title') }}</div>
                            <div class="item-main">
                                <div class="mark">{{ $t('use_proxy.generator.instructions.region') }}</div>
                                <div class="name">{{ $t('use_proxy.generator.instructions.fields') }}</div>
                            </div>
                        </el-form-item> -->
                    </el-form>
                </div>
            </div>

            <div class="info-box">
                <div class="info-box-left">{{ $t('use_proxy.readme.title') }}</div>
                <div class="info-box-right">
                    <table rowspan="0" colspan="0" border="0" style="table-layout:fixed;">
                        <thead>
                            <tr>
                                <th>{{ $t('use_proxy.readme.columns.param') }}</th>
                                <th>{{ $t('use_proxy.readme.columns.annotation') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in annotations" :key="row.name">
                                <td>{{ row.name }}</td>
                                <td>{{ row.anno }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- end -->
        </div>

    </section>
</template>

<script>
import { getProxyRegionList, getProxyStateList, getProxyDomainList } from '@/http/api/home'
import { getProxyUser } from '@/http/api/member'
import { utcTimestampToLocalTime, changeFlowUnit } from '@/util/human'
import regionsUrl from '@/assets/index/regions_en.xlsx'

const maxipnum = 10000
const maxnum = 30

export default {
    name: 'create-proxies',
    components: {
    },

    data() {
        return {
            regionsUrl,
            userTrafficBalance: 0.00,
            displayUserTrafficBalance: '-',
            userTrafficExpireTime: '',
            country: 'global',
            allCountryList: [],
            state: "random",
            stateOptions: [],

            rotation: "staticip",
            ipDuration: 30,
            holdOnTimer: "",
            holdOnIntervals: "",

            preferHost: 'na',
            username: '',
            password: '',
            proxyScripts: '',
            formActive: {
                separator: false,
                host: false,
                username: false,
                password: false,
            },
            accountFormatType: "2",
            ipQuantity: 100,
            accounts: "",

            proxyDomainOptions: [],
            hexCharacters: "0123456789abcdef",
        }
    },
    inject: ['updateCurrentMenuUrl'],
    computed: {
        fields() {
            return this.$t("use_proxy.generator.form");
        },
        rotationOptions() { 
            return [
                { label: this.$t("use_proxy.generator.form.session_options.randomize"), value: "staticip", },
                { label: this.$t("use_proxy.generator.form.session_options.sticky"), value: "timeip" },
            ];
        },
        annotations() {
            return this.$t("use_proxy.readme.rows");
        },
        isLogin() {
            return this.$store.state.isLogin
        },
    },
    created() {
        this.updateCurrentMenuUrl('/ucenter/use_proxy/');
        this.loadProxyUser();
        this.getCountryInfo();
        this.loadProxyDomainList()
    },

    methods: {
        loadProxyDomainList: function () {
            let self = this;
            getProxyDomainList().then(ret => {
                self.proxyDomainOptions = Array.isArray(ret.data) ? ret.data : [];
                self.formActive.host = self.proxyDomainOptions.length > 0;
                self.selectDefaultProxyDomain();
            }).catch(err => {
                let defultProxyDomainOptions = [];
                self.proxyDomainOptions = defultProxyDomainOptions;
                if (defultProxyDomainOptions.length > 0) {
                    self.formActive.host = true;
                    self.selectDefaultProxyDomain();
                }
            })
        },

        morelist: function () {
            this.showResidentialMoreCurlInfo()
        },
        randomPickWeightedDomain: function () {
            let self = this;
            if (!self.proxyDomainOptions.length) {
                return null;
            }

            let totalWeight = 0;
            for (let domain of self.proxyDomainOptions) {
                totalWeight += Math.max(0, Number(domain.weight) || 0);
            }

            if (totalWeight <= 0) {
                const index = Math.floor(Math.random() * self.proxyDomainOptions.length);
                return self.proxyDomainOptions[index];
            }

            let random = Math.random() * totalWeight;
            for (let domain of self.proxyDomainOptions) {
                random -= Math.max(0, Number(domain.weight) || 0);
                if (random <= 0) {
                    return domain;
                }
            }

            return self.proxyDomainOptions[self.proxyDomainOptions.length - 1];
        },
        selectDefaultProxyDomain: function () {
            let domain = this.randomPickWeightedDomain();
            if (!domain) {
                return;
            }

            this.preferHost = domain.id;
            if (this.username && this.password) {
                this.updateProxyScripts();
            }
        },
        pickDomain: function() {
            let self = this;
            var matchedDomain = null;
            for (const key in self.proxyDomainOptions) {
                if (self.proxyDomainOptions[key].id == self.preferHost) {
                    matchedDomain = self.proxyDomainOptions[key];
                }
            }
            if (matchedDomain == null) {
                return self.randomPickWeightedDomain();
            } 
            return matchedDomain;
        },
        showResidentialMoreCurlInfo: function () {
            let self = this;
            self.accounts = ""
            let username = self.username
            let password = self.password

            if (username == '' || password == "") {
                return false
            }
            let dk = "";
            let re = "";
            let time = ""

            let validityTime = self.ipDuration
            if (self.rotation == "timeip") {
                time = `-sesstime-${validityTime}`
            }
            if (self.country != "global") {
                re = `-region-${self.country.toLocaleLowerCase()}`;
                if (self.state && self.state !== "random") {
                    re = re + "-st-" + self.state.toLocaleLowerCase()
                }
            }

            if (self.accountFormatType == 1) {
                let textdatadata = "";
                for (let a = 0; a < self.ipQuantity; a++) {
                    const str = self.randomSession(username);
                    let timeSession = ""
                    if (time) {
                        timeSession = `-sessid-${str}${time}`
                    }
                    let d = self.pickDomain()
                    dk = `${d.address}:${d.port}`
                    const data = `user-${username}${re}${timeSession}:${password}:${dk}`;
                    textdatadata += data + "&#10;";
                }
                self.accounts = textdatadata;
            } else if (self.accountFormatType == 2) {
                let textdatadata = "";
                for (let a = 0; a < self.ipQuantity; a++) {
                    const str = self.randomSession(username);
                    let timeSession = ""
                    if (time) {
                        timeSession = `-sessid-${str}${time}`
                    }
                    let d = self.pickDomain()
                    dk = `${d.address}:${d.port}`
                    const data = `${dk}:user-${username}${re}${timeSession}:${password}`;
                    textdatadata += data + "&#10;";
                }
                self.accounts = textdatadata;
            } else if (self.accountFormatType == 3) {
                let textdatadata = "";
                for (let a = 0; a < self.ipQuantity; a++) {
                    const str = self.randomSession(username);
                    let timeSession = ""
                    if (time) {
                        timeSession = `-sessid-${str}${time}`
                    }
                    let d = self.pickDomain()
                    dk = `${d.address}:${d.port}`
                    const data = `user-${username}${re}${timeSession}:${password}@${dk}`;
                    textdatadata += data + "&#10;";
                }
                self.accounts = textdatadata;
            }
        },

        unopenContinent() {
            this.updateProxyScripts();
        },
        changeAccountFormat: function () {
            this.morelist()
        },
        getCountryInfo: function () {
            let self = this
            self.allCountryList = []
            let lang = 'en';
            getProxyRegionList({ key: '', lang: lang }).then(function (ret) {
                let obj = ret.data;
                let qq = {
                    continents_name: self.$t('use_proxy.generator.form.regions.global'),
                    country_code: "global",
                    country_name: self.$t('use_proxy.generator.form.regions.global'),
                    region: "na",
                }
                // let rsa = {
                //     continents_name: self.$t('use_proxy.generator.form.regions.asia'),
                //     country_code: "rsa",
                //     country_name: self.$t('use_proxy.generator.form.regions.asia'),
                //     region: "as",
                // }
                // let eu = {
                //     continents_name: self.$t('use_proxy.generator.form.regions.europe'),
                //     country_code: "eu",
                //     country_name: self.$t('use_proxy.generator.form.regions.europe'),
                //     region: "eu",
                // }
                // let africa = {
                //     continents_name: self.$t('use_proxy.generator.form.regions.africa'),
                //     country_code: "africa",
                //     country_name: self.$t('use_proxy.generator.form.regions.africa'),
                //     region: "eu",
                // }
                // let north_america = {
                //     continents_name: self.$t('use_proxy.generator.form.regions.north_america'),
                //     country_code: "north_america",
                //     country_name: self.$t('use_proxy.generator.form.regions.north_america'),
                //     region: "na",
                // }
                // let south_america = {
                //     continents_name: self.$t('use_proxy.generator.form.regions.south_america'),
                //     country_code: "south_america",
                //     country_name: self.$t('use_proxy.generator.form.regions.south_america'),
                //     region: "na",
                // }
                // self.allCountryList.push(qq, rsa, eu, africa, north_america, south_america)
                self.allCountryList.push(qq)
                for (let i = 0; i < obj.length; i++) {
                    obj[i].country_name = obj[i].country_name.replace(/(\s*$)/g, '');
                    self.allCountryList.push(obj[i])

                }
                if (self.$refs.selectGlobal) {
                    self.$refs.selectGlobal.$el.children[0].children[0].setAttribute(
                        "style",
                        `background: url("${self.getImgUrl('global')}") no-repeat; background-position: 25px center; background-size: 20px 20px;text-indent: 30px;`
                    );
                }

                self.getStateInfo(self.allCountryList[0].country_code == 'global' ? 'qq' : self.allCountryList[0].country_code)
            }).catch(e => {
                
            });
        },
        getStateInfo: function (code = "") {
            let self = this
            let param = {
                code: code
            }
            self.stateOptions = []
            getProxyStateList(param).then((res) => {
                let obj = {
                    state: "random"
                }

                if (res.data.length > 0) {
                    let data = res.data
                    data.unshift(obj)
                    for (let i = 0; i < data.length; i++) {
                        self.stateOptions.push(data[i])
                    }
                    self.state = 'random'
                } else {
                    self.stateOptions.push(obj)
                    self.state = 'random'
                }
            }).catch((err) => {
                let obj = {
                    state: "random"
                }
                self.stateOptions.push(obj)
                self.state = 'random'
            });
        },

        changeArea: function (val) {
            let index = this.allCountryList.findIndex(
                (item) => item.country_code === val
            );
            this.$refs.selectGlobal.$el.children[0].children[0].setAttribute(
                "style",
                `background: url(${this.getImgUrl(
                    this.allCountryList[index].country_code
                )}) no-repeat; background-position: 25px center; background-size: 20px 20px;text-indent: 30px;outline:none;`
            );

            this.state = 'random'
            this.getStateInfo(val)
            this.updateProxyScripts()
        },

        changeHost: function (reg) {
            this.updateProxyScripts()
        },
        onCloseOption: function (event) {
            let self = this
            let copyType = 0
            if (event.target._prevClass == 'el-input__inner') {
                let copytext = event.target.value;

                const selection = window.getSelection();
                const currentRange = selection.rangeCount === 0 ? null : selection.getRangeAt(0);
                event.target.select();

                if (copytext !== "") {
                    try {
                        document.execCommand('copy');
                        copyType = 1
                    } catch (err) {
                    } finally {
                        selection.removeAllRanges();
                        if (currentRange) {
                            selection.addRange(currentRange);
                        }
                        document.execCommand('copy');
                        copyType = 1
                    }
                }
                
                let laymsg = ''
                let layType = 'error'
                if (copyType) {
                    laymsg = self.$t('use_proxy.message.copy_success')
                    layType = 'success'
                } else {
                    laymsg = self.$t('use_proxy.message.copy_failed')
                }
                self.$message({
                    message: laymsg,
                    type: layType,
                });
            }
        },

        changeState() {
            this.updateProxyScripts()
        },
        changeRotation: function () {
            this.updateProxyScripts()
        },
        dropDown: function () {
            let self = this
            self.changeIpDuration()
            self.updateProxyScripts()
        },
        changeIpDuration: function () {
            let self = this
            let timereg = /^[0-9]+$/;
            const minnum = 1

            if (!timereg.test(self.ipDuration)) {
                self.ipDuration = self.ipDuration.replace(/\D/g, "");
            }
            
            if (self.ipDuration > maxnum) {
                self.ipDuration = maxnum;
            } else if (self.ipDuration < minnum) {
                self.ipDuration = 1;
            }
        },
        incrementDuration: function () {
            let self = this
            
            if (self.ipDuration < maxnum) {
                self.ipDuration++;
            } else {
                self.ipDuration = maxnum;
            }
            self.updateProxyScripts()
        },
        incrementDurationHoldOn: function () {
            let self = this
            self.holdOnTimer = setTimeout(() => {
                self.holdOnIntervals = setInterval(() => {                    
                    if (self.ipDuration < maxnum) {
                        self.ipDuration++;
                    } else {
                        self.ipDuration = maxnum;
                    }
                }, 50);
            }, 500);
        },
        incrementDurationRelease: function () {
            this.clearChangeTime()
            this.updateProxyScripts()
        },
        reduceDuration: function () {
            let self = this
            const minnum = 1

            if (self.ipDuration > minnum) {
                self.ipDuration--;
            } else {
                self.ipDuration = minnum;
            }

            self.updateProxyScripts()
        },
        reduceDurationHoldOn: function () {
            let self = this
            self.holdOnTimer = setTimeout(() => {
                self.holdOnIntervals = setInterval(() => {
                    const minnum = 1

                    if (self.ipDuration > minnum) {
                        self.ipDuration--;
                    } else {
                        self.ipDuration = minnum;
                    }

                }, 50);
            }, 500);
        },
        reduceDurationRelease: function () {
            this.clearChangeTime()
            this.updateProxyScripts()
        },
        clearChangeTime: function () {
            clearTimeout(this.holdOnTimer);
            this.holdOnTimer = "";
            clearInterval(this.holdOnIntervals);
            this.holdOnIntervals = "";
        },

        changeIpQuantity: function () {
            let self = this
            let timereg = /^[0-9]+$/;
            const minnum = 1       

            if (!timereg.test(self.ipQuantity)) {
                self.ipQuantity = self.ipQuantity.replace(/\D/g, "");
            }
            if (self.ipQuantity > maxipnum) {
                self.ipQuantity = maxipnum;
            } else if (self.ipQuantity < minnum) {
                self.ipQuantity = 1;
            }

        },
        incrementQuantity: function () {
            let self = this

            if (self.ipQuantity < maxipnum) {
                self.ipQuantity++;
            }
        },
        reduceQuantity: function () {
            let self = this
            const minnum = 1
            if (self.ipQuantity > minnum) {
                self.ipQuantity--;
            }
        },
        updateProxyScripts: function (state) {
            let self = this
            
            if (self.username !== '') {                
                self.showResidentialScripts();
            } else {
                loadProxyUser(() => {                                                      
                    self.showResidentialScripts();
                });
            }
        },

        showResidentialScripts: function () {
            let self = this
            if (self.userTrafficBalance <= 0) {
                self.$message({
                        message: self.$t('use_proxy.message.no_traffic_balance'),
                        type: 'warning',
                    });
                return false
            }
            let username = self.username
            let password = self.password
            if (username == '' || password == "") {
                return false
            }

            let region = ''
            let st
            let ipti
            let proip;

            if (self.country == 'quanqiuhunbo' || self.country == 'qq' || self.country == 'global') {
                region = ''
            } else {
                region = `-region-${self.country.toLocaleLowerCase()}`
            }
            if (self.state && self.state !== "random") {
                st = "-st-" + self.state
            } else {
                st = ""
            }

            let validityTime = self.ipDuration
            if (self.rotation == 'timeip') {
                ipti = '-sessid-' + self.randomSession(username) + '-sesstime-' + validityTime
            } else {
                ipti = '-sessid-'
            }
            var matchedDomain = null;
            for (const key in self.proxyDomainOptions) {
                if (self.proxyDomainOptions[key].id == self.preferHost) {
                    matchedDomain = self.proxyDomainOptions[key];
                }
            }
            if (matchedDomain == null && self.proxyDomainOptions.length > 0) {
                matchedDomain = self.proxyDomainOptions[0];
            }
            proip = `${matchedDomain.address}:${matchedDomain.port}`
            self.proxyScripts = `curl -x ${proip} -U "user-${username}${region}${st}${ipti}:${password}" ipinfo.io`
        },

        copyLink: function (id) {
            let self = this
            let copyType = 0
            const selection = window.getSelection();
            const currentRange = selection.rangeCount === 0 ? null : selection.getRangeAt(0);
            let copyDom = document.getElementById(id);
            copyDom.select();
            let copyVal = copyDom.value;
            if (copyVal != "") {
                try {
                    document.execCommand('copy');
                    copyType = 1
                } catch (err) {
                } finally {
                    selection.removeAllRanges();
                    if (currentRange) {
                        selection.addRange(currentRange);
                    }
                    document.execCommand('copy');
                    copyType = 1
                }
            }

            let laymsg = ''
            let layType = 'error'
            if (copyType) {
                laymsg = self.$t('use_proxy.message.copy_success')
                layType = 'success'
            } else {
                laymsg = self.$t('use_proxy.message.copy_failed')
            }
            self.$message({
                message: laymsg,
                type: layType,
            });

            event.stopPropagation();
        },

        // other
        loadProxyUser: function (callback) {

            let self = this
            getProxyUser({}).then((ret) => {
                let obj = ret.data;
                self.username = obj.username;
                self.password = obj.password;
                self.userTrafficBalance = obj.balance;
                self.displayUserTrafficBalance = obj.balance ? changeFlowUnit(1e3 * obj.balance) : "0M"
                if (obj.expire_time > 0) {
                    self.userTrafficExpireTime = utcTimestampToLocalTime(obj.expire_time * 1000, 2)
                }
                if (self.proxyDomainOptions.length > 0) {
                    self.updateProxyScripts();
                }
                if (callback != null) {
                    callback();
                }
            }).catch(e => {
                // self.$message.error(e.message ?? e.msg ?? "get proxy info error");
            });
        },
        randomSession: function (username) {
            let self = this
            const c = 8, a = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            let b = '';
            for (let d = c; d > 0; d -= 1) { b += a[Math.floor(Math.random() * a.length)] }
            return self.calcMD5(username + b).substring(0, 12)
        },
        getImgUrl: function (code) {
            // var adress = "@/assets/index/img/resarea/t_" + code.toLowerCase() + ".png"
            // return adress;
            try {
                return require(`@/assets/index/img/resarea/t_${code.toLowerCase()}.png`);
            } catch(e) {
                return "";
            }
        },

        str2blks_MD5: function (str) {
            let nblk = ((str.length + 8) >> 6) + 1;
            let blks = new Array(nblk * 16);
            for (var i = 0; i < nblk * 16; i++) blks[i] = 0;
            for (var i = 0; i < str.length; i++)
                blks[i >> 2] |= str.charCodeAt(i) << ((i % 4) * 8);
            blks[i >> 2] |= 0x80 << ((i % 4) * 8);
            blks[nblk * 16 - 2] = str.length * 8;
            return blks;
        },
        calcMD5: function (str) {
            let self = this
            var x = self.str2blks_MD5(str);
            var a = 1732584193;
            var b = -271733879;
            var c = -1732584194;
            var d = 271733878;

            for (var i = 0; i < x.length; i += 16) {
                var olda = a;
                var oldb = b;
                var oldc = c;
                var oldd = d;

                a = self.ff(a, b, c, d, x[i + 0], 7, -680876936);
                d = self.ff(d, a, b, c, x[i + 1], 12, -389564586);
                c = self.ff(c, d, a, b, x[i + 2], 17, 606105819);
                b = self.ff(b, c, d, a, x[i + 3], 22, -1044525330);
                a = self.ff(a, b, c, d, x[i + 4], 7, -176418897);
                d = self.ff(d, a, b, c, x[i + 5], 12, 1200080426);
                c = self.ff(c, d, a, b, x[i + 6], 17, -1473231341);
                b = self.ff(b, c, d, a, x[i + 7], 22, -45705983);
                a = self.ff(a, b, c, d, x[i + 8], 7, 1770035416);
                d = self.ff(d, a, b, c, x[i + 9], 12, -1958414417);
                c = self.ff(c, d, a, b, x[i + 10], 17, -42063);
                b = self.ff(b, c, d, a, x[i + 11], 22, -1990404162);
                a = self.ff(a, b, c, d, x[i + 12], 7, 1804603682);
                d = self.ff(d, a, b, c, x[i + 13], 12, -40341101);
                c = self.ff(c, d, a, b, x[i + 14], 17, -1502002290);
                b = self.ff(b, c, d, a, x[i + 15], 22, 1236535329);

                a = self.gg(a, b, c, d, x[i + 1], 5, -165796510);
                d = self.gg(d, a, b, c, x[i + 6], 9, -1069501632);
                c = self.gg(c, d, a, b, x[i + 11], 14, 643717713);
                b = self.gg(b, c, d, a, x[i + 0], 20, -373897302);
                a = self.gg(a, b, c, d, x[i + 5], 5, -701558691);
                d = self.gg(d, a, b, c, x[i + 10], 9, 38016083);
                c = self.gg(c, d, a, b, x[i + 15], 14, -660478335);
                b = self.gg(b, c, d, a, x[i + 4], 20, -405537848);
                a = self.gg(a, b, c, d, x[i + 9], 5, 568446438);
                d = self.gg(d, a, b, c, x[i + 14], 9, -1019803690);
                c = self.gg(c, d, a, b, x[i + 3], 14, -187363961);
                b = self.gg(b, c, d, a, x[i + 8], 20, 1163531501);
                a = self.gg(a, b, c, d, x[i + 13], 5, -1444681467);
                d = self.gg(d, a, b, c, x[i + 2], 9, -51403784);
                c = self.gg(c, d, a, b, x[i + 7], 14, 1735328473);
                b = self.gg(b, c, d, a, x[i + 12], 20, -1926607734);

                a = self.hh(a, b, c, d, x[i + 5], 4, -378558);
                d = self.hh(d, a, b, c, x[i + 8], 11, -2022574463);
                c = self.hh(c, d, a, b, x[i + 11], 16, 1839030562);
                b = self.hh(b, c, d, a, x[i + 14], 23, -35309556);
                a = self.hh(a, b, c, d, x[i + 1], 4, -1530992060);
                d = self.hh(d, a, b, c, x[i + 4], 11, 1272893353);
                c = self.hh(c, d, a, b, x[i + 7], 16, -155497632);
                b = self.hh(b, c, d, a, x[i + 10], 23, -1094730640);
                a = self.hh(a, b, c, d, x[i + 13], 4, 681279174);
                d = self.hh(d, a, b, c, x[i + 0], 11, -358537222);
                c = self.hh(c, d, a, b, x[i + 3], 16, -722521979);
                b = self.hh(b, c, d, a, x[i + 6], 23, 76029189);
                a = self.hh(a, b, c, d, x[i + 9], 4, -640364487);
                d = self.hh(d, a, b, c, x[i + 12], 11, -421815835);
                c = self.hh(c, d, a, b, x[i + 15], 16, 530742520);
                b = self.hh(b, c, d, a, x[i + 2], 23, -995338651);

                a = self.ii(a, b, c, d, x[i + 0], 6, -198630844);
                d = self.ii(d, a, b, c, x[i + 7], 10, 1126891415);
                c = self.ii(c, d, a, b, x[i + 14], 15, -1416354905);
                b = self.ii(b, c, d, a, x[i + 5], 21, -57434055);
                a = self.ii(a, b, c, d, x[i + 12], 6, 1700485571);
                d = self.ii(d, a, b, c, x[i + 3], 10, -1894986606);
                c = self.ii(c, d, a, b, x[i + 10], 15, -1051523);
                b = self.ii(b, c, d, a, x[i + 1], 21, -2054922799);
                a = self.ii(a, b, c, d, x[i + 8], 6, 1873313359);
                d = self.ii(d, a, b, c, x[i + 15], 10, -30611744);
                c = self.ii(c, d, a, b, x[i + 6], 15, -1560198380);
                b = self.ii(b, c, d, a, x[i + 13], 21, 1309151649);
                a = self.ii(a, b, c, d, x[i + 4], 6, -145523070);
                d = self.ii(d, a, b, c, x[i + 11], 10, -1120210379);
                c = self.ii(c, d, a, b, x[i + 2], 15, 718787259);
                b = self.ii(b, c, d, a, x[i + 9], 21, -343485551);

                a = self.add(a, olda);
                b = self.add(b, oldb);
                c = self.add(c, oldc);
                d = self.add(d, oldd);
            }
            return self.rhex(a) + self.rhex(b) + self.rhex(c) + self.rhex(d);
        },
        cmn: function (q, a, b, x, s, t) {
            return this.add(this.rol(this.add(this.add(a, q), this.add(x, t)), s), b);
        },
        ff: function (a, b, c, d, x, s, t) {
            return this.cmn((b & c) | ((~b) & d), a, b, x, s, t);
        },
        gg: function (a, b, c, d, x, s, t) {
            return this.cmn((b & d) | (c & (~d)), a, b, x, s, t);
        },
        hh: function (a, b, c, d, x, s, t) {
            return this.cmn(b ^ c ^ d, a, b, x, s, t);
        },
        ii: function (a, b, c, d, x, s, t) {
            return this.cmn(c ^ (b | (~d)), a, b, x, s, t);
        },
        rol: function (num, cnt) {
            return (num << cnt) | (num >>> (32 - cnt));
        },
        add: function (x, y) {
            var lsw = (x & 0xFFFF) + (y & 0xFFFF);
            var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
            return (msw << 16) | (lsw & 0xFFFF);
        },
        rhex: function (num) {
            let self = this
            var str = "";
            for (var j = 0; j <= 3; j++)
                str += self.hexCharacters.charAt((num >> (j * 8 + 4)) & 0x0F) +
                    self.hexCharacters.charAt((num >> (j * 8)) & 0x0F);
            return str;
        },
    },
}

</script>

<style lang="scss">
.resproxy {
    width: 100%;
    height: 100%
}

.resproxy .use-resprox--content {
    display: none
}

.resproxy .tab-cont {
    width: 100%;
    height: 100%
}

@media (max-width: 960px) {
    .resproxy .tab-cont {
        display: none
    }
}

.resproxy .tab-cont .useproxy-top-select-box {
    width: 100%
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-select {
    width: 100%
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-select .useproxy-top-select-ul {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-select .useproxy-top-select-ul .useproxy-select-item {
    padding: 12px 32px;
    border-top: 1px solid #F0F2F9;
    border-left: 1px solid #F0F2F9;
    border-right: 1px solid #F0F2F9;
    background-color: #fff;
    border-radius: 8px 8px 0 0;
    cursor: pointer;
    font-size: 14px;
    font-family: 'Poppins-Medium';
    color: #223367;
    line-height: 1
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-select .useproxy-top-select-ul .useproxy-select-item:not(:last-of-type) {
    margin-right: 2px
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-select .useproxy-top-select-ul .useproxy-select-item.active {
    border-top: 1px solid #223265;
    border-left: 1px solid #223265;
    border-right: 1px solid #223265;
    background: #223265;
    color: #fff
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-basic-info-box {
    width: 100%;
    border-radius: 8px 8px 8px 8px;
    background: #223265;
    padding: 30px 36px;
    box-sizing: border-box
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-basic-info-box .useproxy-detail-box {
    width: 100%;
    height: 100%;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-basic-info-box .useproxy-detail-box .useproxy-detail-box-left {
    line-height: 1
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-basic-info-box .useproxy-detail-box .useproxy-detail-box-left .useproxy-detail-tit {
    font-size: 24px;
    font-family: 'Poppins-Black';
    font-weight: bold;
    color: #fff
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-basic-info-box .useproxy-detail-box .useproxy-detail-box-left .useproxy-detail-info {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-basic-info-box .useproxy-detail-box .useproxy-detail-box-left .useproxy-detail-info .useproxy-detail-flow {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 40px;
    font-family: 'Poppins-Black';
    font-weight: bold;
    color: #fff;
    line-height: 1
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-basic-info-box .useproxy-detail-box .useproxy-detail-box-left .useproxy-detail-info .useproxy-detail-time {
    margin-left: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    font-family: 'Poppins-Medium';
    font-weight: 400;
    color: #fff;
    line-height: 1
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-basic-info-box .useproxy-detail-box .useproxy-detail-box-left .useproxy-detail-info .useproxy-detail-time .useproxy-detail-time-icon {
    cursor: pointer;
    margin-right: 5px
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-basic-info-box .useproxy-detail-box .useproxy-detail-box-left .useproxy-detail-info .useproxy-detail-time .useproxy-detail-time-box {
    display: flex;
    justify-content: flex-start;
    align-items: center
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-basic-info-box .useproxy-detail-box .useproxy-detail-box-left .useproxy-detail-info .useproxy-detail-time.useproxy-detail-noflow {
    margin-left: 0
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-basic-info-box .useproxy-detail-box .useproxy-detail-box-right .btn {
    width: 120px;
    height: 46px;
    background-color: #276dfd;
    border-radius: 8px;
    text-align: center;
    line-height: 46px;
    cursor: pointer;
    font-family: 'Poppins-SemiBold';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff
}

.resproxy .tab-cont .useproxy-top-select-box .useproxy-top-basic-info-box .useproxy-detail-box .useproxy-detail-box-right .btn a {
    display: block;
    width: 100%;
    height: 100%;
    text-decoration: none;
    color: #ffffff
}

.resproxy .tab-cont .tab-box {
    width: 100%;
    display: flex;
    justify-content: space-between
}

.resproxy .tab-cont .tab-box .title-box {
    width: calc(49% - 80px);
    min-height: 70px;
    padding: 32px 40px;
    background-color: #ffffff;
    box-shadow: 0px 3px 21px 0px rgba(34, 50, 101, 0.1);
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    color: #223265;
    cursor: pointer
}

.resproxy .tab-cont .tab-box .title-box .title-box-left {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
}

.resproxy .tab-cont .tab-box .title-box .title-box-left .title-box-left-icon {
    margin-right: 26px
}

.resproxy .tab-cont .tab-box .title-box .title-box-left .title-box-left-icon .noactive {
    display: block
}

.resproxy .tab-cont .tab-box .title-box .title-box-left .title-box-left-icon .active {
    display: none
}

.resproxy .tab-cont .tab-box .title-box .title-box-left .title-box-left-main .title-box-left-tit {
    font-family: 'Poppins-Bold';
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 35px;
    letter-spacing: 0px
}

.resproxy .tab-cont .tab-box .title-box .title-box-left .title-box-left-main .title-box-left-tip {
    font-family: 'Poppins-Bold';
    font-size: 40px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 56px;
    letter-spacing: 0px
}

.resproxy .tab-cont .tab-box .title-box .title-box-left .title-box-left-main .title-box-left-tip.small {
    font-size: 24px
}

.resproxy .tab-cont .tab-box .title-box .title-box-right {
    display: flex;
    align-items: center
}

.resproxy .tab-cont .tab-box .title-box .title-box-right .btn {
    width: 120px;
    height: 46px;
    background-color: rgba(39, 109, 253, 0.1);
    border-radius: 8px;
    text-align: center;
    line-height: 46px;
    cursor: pointer;
    font-family: 'Poppins-SemiBold';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #276dfd
}

.resproxy .tab-cont .tab-box .title-box .title-box-right .btn a {
    display: block;
    width: 100%;
    height: 100%;
    text-decoration: none;
    color: #276dfd
}

.resproxy .tab-cont .tab-box .title-box.active {
    background-color: #223265;
    color: #ffffff
}

.resproxy .tab-cont .tab-box .title-box.active .title-box-left .title-box-left-icon .noactive {
    display: none
}

.resproxy .tab-cont .tab-box .title-box.active .title-box-left .title-box-left-icon .active {
    display: block
}

.resproxy .tab-cont .tab-box .title-box.active .title-box-right .btn {
    background-color: #276dfd;
    color: #ffffff
}

.resproxy .tab-cont .tab-box .title-box.active .title-box-right .btn a {
    color: #ffffff
}

.resproxy .tab-cont .form-box {
    margin-top: 40px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
}

.resproxy .tab-cont .form-box .form-left {
    width: 256px;
    font-family: "Poppins-Bold";
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.resproxy .tab-cont .form-box .form-right {
    width: calc(100% - 256px);
    max-width: 950px
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 {
    width: 100%;
    height: 66px;
    margin-right: 0px;
    margin-bottom: 39px;
    box-sizing: border-box;
    background-color: #f0f2f9;
    border-radius: 10px
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__label {
    display: none
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    margin: 13px auto
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content .el-input .el-input__inner {
    width: 100%;
    padding-left: 24px;
    border: none;
    outline: 0;
    background-color: #f0f2f9;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content .el-input .el-input__inner::-webkit-outer-spin-button,
.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content .el-input .el-input__inner::-webkit-inner-spin-button {
    -webkit-appearance: none
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content .el-input .el-input__inner[type="number"] {
    -moz-appearance: textfield
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content>span {
    line-height: 20px;
    cursor: pointer
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content>span>.el-input__icon {
    line-height: 20px;
    font-size: 14px;
    color: #26497c
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content>span:active {
    transform: scale(1.3)
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content>span:first-of-type {
    display: block;
    width: 35px;
    height: 50%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0px;
    top: -6px;
    cursor: pointer
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content>span:last-of-type {
    display: block;
    width: 35px;
    height: 50%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0px;
    bottom: 6px;
    cursor: pointer
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f2 {
    width: 100%;
    height: 66px;
    margin-right: 0px;
    margin-bottom: 39px;
    box-sizing: border-box;
    background-color: #f0f2f9;
    border-radius: 10px
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f2 .el-form-item__label {
    display: none
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f2 .el-form-item__content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin: 13px auto
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f2 .el-form-item__content .el-select {
    width: 100%;
    box-sizing: border-box
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f2 .el-form-item__content .el-select .el-input {
    width: 100%;
    box-sizing: border-box
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f2 .el-form-item__content .el-select .el-input .el-input__inner {
    width: 100%;
    padding-left: 24px;
    border: none;
    background-color: #f0f2f9;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f2 .el-form-item__content .el-select .el-input .el-input__suffix {
    top: -6px
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f2 .el-form-item__content .el-select .el-input .el-select__caret {
    font-size: 16px;
    color: #464c5f
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f6 {
    width: 100%;
    height: 66px
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__content .generateApi {
    width: 100%;
    max-width: 245px;
    height: 66px;
    border: none;
    outline: none;
    display: block;
    background-color: #276dfd;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 66px;
    letter-spacing: 0px;
    color: #ffffff;
    cursor: pointer
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__content .helps {
    position: relative
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__content .helps:hover .txt {
    display: block
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__content .helps img {
    position: absolute;
    top: 0;
    left: 11px
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__content .helps .txt {
    display: none;
    padding: 4px 11px;
    margin-left: 46px;
    background-color: rgba(34, 50, 101, 0.1);
    border-radius: 6px;
    font-family: "Poppins-Medium";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 21px;
    letter-spacing: 0px;
    color: #223265
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.act .el-form-item__label {
    display: inline-block;
    margin-top: 8px;
    padding-left: 24px;
    font-family: 'Poppins-Medium';
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: 0px;
    color: rgba(17, 24, 46, 0.2)
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.act .el-form-item__content {
    margin: 0 auto
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.act .el-form-item__content .el-select .el-input .el-input__suffix {
    top: -6px
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item.act .el-form-item__content .el-input .el-input__suffix {
    top: -6px
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline.demo-unform-inline .el-form-item:nth-of-type(1) .el-form-item__content .el-input {
    width: 100%;
    box-sizing: border-box
}

.resproxy .tab-cont .form-box .form-right .demo-form-inline.demo-unform-inline .el-form-item:nth-of-type(1) .el-form-item__content .el-input .el-input__inner {
    width: 100%;
    padding-left: 24px;
    border: none;
    background-color: #f0f2f9;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e;
    background: url("@/assets/index/img/ucenter/api/area/t_qq.png") no-repeat;
    background-position: 25px center;
    background-size: 20px 20px;
    text-indent: 30px
}

.resproxy .tab-cont .link-box {
    width: 100%;
    margin-top: 40px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
}

.resproxy .tab-cont .link-box .link-box-left {
    width: 256px;
    font-family: "Poppins-Bold";
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.resproxy .tab-cont .link-box .link-box-right {
    width: calc(100% - 256px);
    max-width: 950px
}

.resproxy .tab-cont .link-box .link-box-right .link-form {
    width: 100%
}

.resproxy .tab-cont .link-box .link-box-right .link-form .link-form-item {
    width: 100%;
    height: 66px;
    margin-bottom: 21px
}

.resproxy .tab-cont .link-box .link-box-right .link-form .link-form-item:first-of-type .api_input {
    width: 100%;
    height: 66px;
    padding-left: 24px;
    border: none;
    outline: 0;
    background-color: #f0f2f9;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.resproxy .tab-cont .link-box .link-box-right .link-form .link-form-item:nth-of-type(2) {
    width: 100%;
    height: 66px
}

.resproxy .tab-cont .link-box .link-box-right .link-form .link-form-item:nth-of-type(2) .open-link-btn {
    width: 100%;
    max-width: 245px;
    height: 66px;
    margin-right: 24px;
    border: none;
    outline: none;
    display: inline-block;
    background-color: #276dfd;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 66px;
    letter-spacing: 0px;
    color: #ffffff;
    cursor: pointer
}

.resproxy .tab-cont .link-box .link-box-right .link-form .link-form-item:nth-of-type(2) .copy-link-btn {
    width: 100%;
    max-width: 245px;
    height: 66px;
    border: none;
    outline: none;
    display: inline-block;
    background-color: rgba(39, 109, 253, 0.1);
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 66px;
    letter-spacing: 0px;
    color: #276dfd;
    cursor: pointer
}

.resproxy .tab-cont .link-box .link-box-right .link-info {
    width: calc(100% - 48px);
    padding: 24px 24px;
    background-color: #f0f2f9;
    border-radius: 10px
}

.resproxy .tab-cont .link-box .link-box-right .link-info .link-info-title {
    margin-bottom: 19px;
    font-family: 'Poppins-Bold';
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 37px;
    letter-spacing: 0px;
    color: #11182e
}

.resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content {
    width: 100%
}

.resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content .link-info-item {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
}

.resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content .link-info-item .link-info-list {
    margin-bottom: 25px;
    padding-left: 23px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    line-height: 23px
}

.resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content .link-info-item .link-info-list::before {
    content: '';
    width: 8px;
    height: 8px;
    background-color: #276dfd;
    border-radius: 2px;
    position: relative;
    top: 8px;
    left: -20px
}

.resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content .link-info-item .link-info-list .mark {
    margin-left: 0;
    margin-right: 16px;
    display: inline-block;
    height: 23px;
    background-color: rgba(39, 109, 253, 0.1);
    border-radius: 4px;
    padding: 0 11px;
    font-family: "Poppins-Medium";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 23px;
    letter-spacing: 0px;
    color: rgba(17, 24, 46, 0.6)
}

@media screen and (max-width: 800px) {
    .resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content .link-info-item .link-info-list .name {
        width: calc(100% - 130px)
    }
}

.resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content .link-info-item .link-info-list .name {
    font-family: "Poppins-Medium";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 23px;
    letter-spacing: 0px;
    word-wrap: break-word;
    word-break: break-all;
    color: #11182e
}

.resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content .link-info-item .link-info-list:first-of-type {
    min-width: 560px
}

@media screen and (max-width: 1200px) {
    .resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content .link-info-item .link-info-list:first-of-type {
        max-width: 300px;
        min-width: auto
    }
}

.resproxy .tab-cont .example-box {
    width: 100%;
    margin-top: 40px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
}

.resproxy .tab-cont .example-box .example-box-left {
    width: 256px;
    font-family: "Poppins-Bold";
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.resproxy .tab-cont .example-box .example-box-right {
    width: calc(100% - 256px);
    max-width: 950px
}

.resproxy .tab-cont .example-box .example-box-right .example-info {
    width: calc(100% - 48px);
    padding: 24px 37px;
    background-color: #f0f2f9;
    border-radius: 10px
}

.resproxy .tab-cont .example-box .example-box-right .example-info .example-data {
    font-family: "Poppins-Medium";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 37px;
    letter-spacing: 0px;
    color: #11182e
}

.resproxy .tab-cont .example-box .example-box-right .example-info .example-par {
    margin-top: 35px
}

.resproxy .tab-cont .example-box .example-box-right .example-info .example-par .example-par-title {
    margin-bottom: 19px;
    font-family: 'Poppins-Bold';
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 37px;
    letter-spacing: 0px;
    color: #11182e
}

.resproxy .tab-cont .example-box .example-box-right .example-info .example-par .example-par-content {
    width: 100%
}

.resproxy .tab-cont .example-box .example-box-right .example-info .example-par .example-par-content .example-par-item {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
}

.resproxy .tab-cont .example-box .example-box-right .example-info .example-par .example-par-content .example-par-item .example-par-list {
    margin-bottom: 25px;
    padding-left: 23px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    line-height: 23px
}

.resproxy .tab-cont .example-box .example-box-right .example-info .example-par .example-par-content .example-par-item .example-par-list::before {
    content: '';
    width: 8px;
    height: 8px;
    background-color: #276dfd;
    border-radius: 2px;
    position: relative;
    top: 8px;
    left: -23px
}

.resproxy .tab-cont .example-box .example-box-right .example-info .example-par .example-par-content .example-par-item .example-par-list .mark {
    margin-left: 0;
    margin-right: 16px;
    display: inline-block;
    height: 23px;
    background-color: rgba(39, 109, 253, 0.1);
    border-radius: 4px;
    padding: 0 11px;
    font-family: "Poppins-Medium";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 23px;
    letter-spacing: 0px;
    color: rgba(17, 24, 46, 0.6)
}

.resproxy .tab-cont .example-box .example-box-right .example-info .example-par .example-par-content .example-par-item .example-par-list .name {
    display: inline-block;
    font-family: "Poppins-Medium";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 23px;
    letter-spacing: 0px;
    color: #11182e
}

.resproxy .tab-cont .example-box .example-box-right .example-info .example-par .example-par-content .example-par-item .example-par-list:first-of-type {
    min-width: 560px
}

@media screen and (max-width: 1200px) {
    .resproxy .tab-cont .example-box .example-box-right .example-info .example-par .example-par-content .example-par-item .example-par-list:first-of-type {
        max-width: 300px;
        min-width: auto
    }
}

.resproxy .ip_white_dialog_bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1004;
    background: rgba(0, 0, 0, 0.2)
}

.resproxy .el-dialog.el-dialog--center {
    margin-top: 0 !important;
    top: 50%;
    transform: translateY(-50%)
}


.account {
    width: 100%;
    height: 100%
}

.account .tab-cont {
    width: 100%;
    height: 100%
}

.account .tab-cont .tab-box {
    width: 100%;
    display: flex;
    justify-content: space-between
}

.account .tab-cont .tab-box .title-box {
    width: calc(49% - 80px);
    min-height: 70px;
    padding: 32px 40px;
    background-color: #ffffff;
    box-shadow: 0px 3px 21px 0px rgba(34, 50, 101, 0.1);
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    color: #223265
}

.account .tab-cont .tab-box .title-box .title-box-left {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
}

.account .tab-cont .tab-box .title-box .title-box-left .title-box-left-icon {
    margin-right: 26px
}

.account .tab-cont .tab-box .title-box .title-box-left .title-box-left-icon .noactive {
    display: block
}

.account .tab-cont .tab-box .title-box .title-box-left .title-box-left-icon .active {
    display: none
}

.account .tab-cont .tab-box .title-box .title-box-left .title-box-left-main .title-box-left-tit {
    font-family: 'Poppins-Bold';
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 35px;
    letter-spacing: 0px
}

.account .tab-cont .tab-box .title-box .title-box-left .title-box-left-main .title-box-left-tip {
    font-family: 'Poppins-Bold';
    font-size: 40px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 56px;
    letter-spacing: 0px
}

.account .tab-cont .tab-box .title-box .title-box-left .title-box-left-main .title-box-left-tip.small {
    font-size: 24px
}

.account .tab-cont .tab-box .title-box .title-box-right {
    display: flex;
    align-items: center
}

.account .tab-cont .tab-box .title-box .title-box-right .btn {
    width: 120px;
    height: 46px;
    background-color: rgba(39, 109, 253, 0.1);
    border-radius: 8px;
    text-align: center;
    line-height: 46px;
    cursor: pointer;
    font-family: 'Poppins-SemiBold';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #276dfd
}

.account .tab-cont .tab-box .title-box.active {
    background-color: #223265;
    color: #ffffff
}

.account .tab-cont .tab-box .title-box.active .title-box-left .title-box-left-icon .noactive {
    display: none
}

.account .tab-cont .tab-box .title-box.active .title-box-left .title-box-left-icon .active {
    display: block
}

.account .tab-cont .tab-box .title-box.active .title-box-right .btn {
    background-color: #276dfd;
    color: #ffffff
}

.account .tab-cont .form-box {
    margin-top: 40px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
}

.account .tab-cont .form-box .form-left {
    width: 256px;
    font-family: "Poppins-Bold";
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .form-box .form-right {
    width: calc(100% - 256px);
    max-width: 950px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 {
    width: 100%;
    height: 66px;
    margin-right: 0px;
    margin-bottom: 39px;
    box-sizing: border-box;
    background-color: #f0f2f9;
    border-radius: 10px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__label {
    display: none
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin: 13px auto
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content .el-select {
    width: 100%;
    box-sizing: border-box
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content .el-select .el-input {
    width: 100%;
    box-sizing: border-box
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content .el-select .el-input .el-input__inner {
    width: 100%;
    padding-left: 24px;
    border: none;
    background-color: #f0f2f9;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content .el-select .el-input .el-input__suffix {
    top: -6px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content .el-select .el-input .el-select__caret {
    font-size: 16px;
    color: #464c5f
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.changbox {
    width: 100%;
    max-width: 462px;
    height: 66px;
    margin-right: 0px;
    margin-bottom: 39px;
    box-sizing: border-box;
    background-color: #f0f2f9;
    border-radius: 10px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.changbox .el-form-item__content {
    width: 100%;
    height: 100%
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.changbox .selectBox {
    line-height: 66px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e;
    padding: 0 24px;
    user-select: none;
    width: 100%;
    cursor: pointer;
    box-sizing: border-box;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.changbox .selectBox .roid {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 17px;
    height: 17px;
    background-color: white;
    border: 1px solid #ccc
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.changbox .selectBox .roid i {
    font-size: 14px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.changbox .selectBox.active .roid {
    border: 1px solid #13ce66;
    background-color: #13ce66
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.changbox .selectBox.active .roid i {
    color: white
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.changbox.m24 {
    margin-right: 24px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.a_down {
    margin: 0;
    margin-left: 10px;
    height: 66px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.a_down .el-form-item__content {
    height: 100%;
    line-height: 66px;
    letter-spacing: 0px;
    color: #276dfd;
    font-family: "Poppins-Medium";
    text-decoration: underline;
    font-size: 16px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.a_down .el-form-item__content a {
    color: #276dfd;
    font-family: "Poppins-Medium";
    text-decoration: underline;
    font-size: 16px
}


.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f2 .el-form-item__content .el-select .el-input .el-input__suffix {
    top: -6px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f2 .el-form-item__content .el-select .el-input .el-select__caret {
    font-size: 16px;
    color: #464c5f
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.z_f2 {
    max-width: 350px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f2 {
    margin-right: 24px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f2_isp {
    max-width: 621px;
    margin-right: 0
}


.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f6 {
    width: 100%;
    height: 66px;
    margin-right: 0px;
    margin-bottom: 39px;
    box-sizing: border-box;
    background-color: #f0f2f9;
    border-radius: 10px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__label {
    display: none
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin: 13px auto
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__content .el-select {
    width: 100%;
    box-sizing: border-box
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__content .el-select .el-input {
    width: 100%;
    box-sizing: border-box
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__content .el-select .el-input .el-input__inner {
    width: 100%;
    padding-left: 24px;
    border: none;
    background-color: #f0f2f9;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__content .el-select .el-input .el-input__suffix {
    top: -6px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__content .el-select .el-input .el-select__caret {
    font-size: 16px;
    color: #464c5f
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f6.show-time {
    max-width: 462px;
    margin-right: 24px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f7 {
    width: 100%;
    height: 66px;
    margin-right: 0px;
    margin-bottom: 39px;
    box-sizing: border-box;
    background-color: #f0f2f9;
    border-radius: 10px
}
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f7 .el-form-item__label {
    display: none
}
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f7 .el-form-item__content {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    margin: 13px auto
}
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f7 .el-form-item__content .el-input .el-input__inner {
    width: 100%;
    padding-left: 24px;
    border: none;
    outline: 0;
    background-color: #f0f2f9;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f7 .el-form-item__content .el-input .el-input__inner::-webkit-outer-spin-button,.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f7 .el-form-item__content .el-input .el-input__inner::-webkit-inner-spin-button {
    -webkit-appearance: none
}
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f7 .el-form-item__content .el-input .el-input__inner[type="number"] {
    -moz-appearance: textfield
}
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f7 .el-form-item__content>span {
    line-height: 20px;
    cursor: pointer
}
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f7 .el-form-item__content>span>.el-input__icon {
    line-height: 20px;
    font-size: 14px;
    color: #26497c
}
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f7 .el-form-item__content>span:active {
    transform: scale(1.3)
}
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f7 .el-form-item__content>span:first-of-type {
    display: block;
    width: 35px;
    height: 50%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0px;
    top: -6px;
    cursor: pointer
}
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f7 .el-form-item__content>span:last-of-type {
    display: block;
    width: 35px;
    height: 50%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0px;
    bottom: 6px;
    cursor: pointer
}
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f7.show-time {
    max-width: 462px
}
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f7.hide-time {
    display: none
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f8,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f9,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f10 {
    width: 100%;
    max-width: 297px;
    height: 66px;
    margin-right: 0px;
    margin-bottom: 39px;
    box-sizing: border-box;
    background-color: #f0f2f9;
    border-radius: 10px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f8 .el-form-item__label,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f9 .el-form-item__label,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f10 .el-form-item__label {
    display: none
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f8 .el-form-item__content,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f9 .el-form-item__content,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f10 .el-form-item__content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin: 13px auto
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f8 .el-form-item__content .el-input,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f9 .el-form-item__content .el-input,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f10 .el-form-item__content .el-input {
    width: 100%;
    box-sizing: border-box
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f8 .el-form-item__content .el-input .el-input__inner,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f9 .el-form-item__content .el-input .el-input__inner,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f10 .el-form-item__content .el-input .el-input__inner {
    width: 100%;
    padding-left: 24px;
    border: none;
    background-color: #f0f2f9;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f8 .el-form-item__content .el-select,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f9 .el-form-item__content .el-select,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f10 .el-form-item__content .el-select {
    width: 100%;
    box-sizing: border-box
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f8 .el-form-item__content .el-select__caret,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f9 .el-form-item__content .el-select__caret,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f10 .el-form-item__content .el-select__caret {
    font-size: 16px;
    color: #464c5f
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f8.show-time,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f9.show-time,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f10.show-time {
    max-width: 462px;
    margin-right: 24px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f8,
.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f9 {
    margin-right: 26px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.f9 .el-input__inner {
    cursor: pointer
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.act .el-form-item__label {
    display: inline-block;
    margin-top: 8px;
    padding-left: 24px;
    font-family: 'Poppins-Medium';
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: 0px;
    color: rgba(17, 24, 46, 0.2)
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.act .el-form-item__content {
    margin: 0 auto
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.act .el-form-item__content .el-select .el-input .el-input__suffix {
    top: -6px
}

.account .tab-cont .form-box .form-right .demo-form-inline .el-form-item.act .el-form-item__content .el-input .el-input__suffix {
    top: -6px
}

.account .tab-cont .link-box {
    margin-top: 40px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
}

.account .tab-cont .link-box .link-box-left {
    width: 256px;
    font-family: "Poppins-Bold";
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .link-box .link-box-right {
    width: calc(100% - 256px);
    max-width: 950px
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item {
    width: 100%;
    height: 66px;
    margin-right: 0px;
    margin-bottom: 39px;
    box-sizing: border-box;
    background-color: #f0f2f9;
    border-radius: 10px
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item .el-form-item__label {
    display: none
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item .el-form-item__content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin: 13px auto
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item .el-form-item__content .el-input {
    width: 100%;
    box-sizing: border-box
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item .el-form-item__content .el-input .el-input__inner {
    width: 100%;
    padding-left: 24px;
    border: none;
    background-color: #f0f2f9;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.link-form-btn {
    background: transparent
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.link-form-btn .el-form-item__content {
    margin: 0
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.link-form-btn .el-form-item__content .copy-link-btn {
    width: 100%;
    max-width: 245px;
    height: 66px;
    display: inline-block;
    outline: none;
    border: none;
    background-color: #276dfd;
    border-radius: 10px;
    font-family: "Poppins-Medium";
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 66px;
    letter-spacing: 0px;
    color: #ffffff;
    cursor: pointer
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.link-form-instructions {
    width: 100%;
    height: auto;
    min-height: 124px;
    padding: 24px 24px
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.link-form-instructions .el-form-item__content {
    margin: 0
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.link-form-instructions .el-form-item__content .item-title {
    font-family: "Poppins-Bold";
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 33px;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.link-form-instructions .el-form-item__content .item-main {
    margin-top: 19px;
    padding-left: 28px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.link-form-instructions .el-form-item__content .item-main::before {
    content: '';
    width: 8px;
    height: 8px;
    background-color: #276dfd;
    border-radius: 2px;
    position: relative;
    top: 8px;
    left: -28px
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.link-form-instructions .el-form-item__content .item-main .mark {
    margin-right: 8px;
    padding: 0 13px;
    background-color: rgba(39, 109, 253, 0.1);
    border-radius: 4px;
    font-family: "Poppins-Medium";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 23px;
    letter-spacing: 0px;
    color: rgba(17, 24, 46, 0.6)
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.link-form-instructions .el-form-item__content .item-main .name {
    margin-left: 8px;
    font-family: "Poppins-Medium";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 23px;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.act {
    max-width: 462px
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.act.rightmg {
    margin-right: 24px
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.act .el-form-item__label {
    display: inline-block;
    margin-top: 8px;
    padding-left: 24px;
    font-family: 'Poppins-Medium';
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: 0px;
    color: rgba(17, 24, 46, 0.2)
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.act .el-form-item__content {
    margin: 0 auto
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.act .el-form-item__content .el-select {
    width: 100%
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.act .el-form-item__content .el-select .el-input .el-input__suffix {
    top: -6px
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.act .el-form-item__content .el-input .el-input__suffix {
    top: -6px
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.act .el-form-item__content .el-input__inner::-webkit-outer-spin-button,
.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.act .el-form-item__content .el-input__inner::-webkit-inner-spin-button {
    -webkit-appearance: none
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.act .el-form-item__content .el-input__inner[type="number"] {
    -moz-appearance: textfield
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.numinp {
    width: 100%;
    box-sizing: border-box;
    position: relative
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.numinp .el-form-item__content {
    height: auto
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.numinp span {
    width: 35px;
    height: 50%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0px;
    cursor: pointer
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.numinp span.first {
    top: -6px
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.numinp span.last {
    bottom: 6px
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.numinp span i {
    line-height: 20px;
    font-size: 14px;
    color: #26497c
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.links {
    height: auto;
    padding: 10px 24px;
    margin-bottom: 10px;
    padding-bottom: 0px
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.links .el-form-item__content {
    margin-bottom: 0px
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.links textarea {
    width: 100%;
    height: 100%;
    background-color: #f0f2f9;
    border: 0
}

@media (max-width: 425px) {
    .account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.links textarea {
        font-size: 12px
    }
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.links1 {
    height: auto;
    padding: 10px 24px;
    margin-bottom: 10px;
    padding-bottom: 0px
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.links1 .el-form-item__content {
    margin-bottom: 0px
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.links1 textarea {
    width: 100%;
    height: 100%;
    background-color: #f0f2f9;
    border: 0
}

@media (max-width: 425px) {
    .account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.links1 textarea {
        font-size: 12px
    }
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.btn {
    max-width: 240px;
    background-color: white;
    margin-right: 24px
}

.account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.btn .btn-btn {
    width: 100%;
    padding: 0 10px;
    height: 66px;
    display: inline-block;
    outline: none;
    border: none;
    background-color: #276dfd;
    border-radius: 10px;
    font-family: "Poppins-Medium";
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 66px;
    letter-spacing: 0px;
    color: #ffffff;
    cursor: pointer
}

@media (max-width: 425px) {
    .account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item.btn .btn-btn {
        font-size: 14px
    }
}

.account .tab-cont .unform-box {
    margin-top: 40px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
}

.account .tab-cont .unform-box .form-left {
    width: 256px;
    font-family: "Poppins-Bold";
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .unform-box .form-right {
    width: calc(100% - 256px);
    max-width: 950px
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f1 {
    width: 100%;
    height: 66px;
    margin-right: 0px;
    margin-bottom: 39px;
    box-sizing: border-box;
    background-color: #f0f2f9;
    border-radius: 10px
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f1 .el-select {
    width: 100%
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__label {
    display: none
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin: 13px auto
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content .el-input {
    width: 100%;
    box-sizing: border-box
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content .el-input .el-input__inner {
    width: 100%;
    padding-left: 24px;
    border: none;
    background-color: #f0f2f9;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e;
    background: url("@/assets/index/img/ucenter/api/area/t_qq.png") no-repeat;
    background-position: 25px center;
    background-size: 20px 20px;
    text-indent: 30px
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content .el-input .el-input__suffix {
    top: -6px
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f1 .el-form-item__content .el-input .el-select__caret {
    font-size: 16px;
    color: #464c5f
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f2 {
    width: 100%;
    max-width: 621px;
    height: 66px;
    margin-right: 0px;
    margin-bottom: 39px;
    box-sizing: border-box;
    background-color: #f0f2f9;
    border-radius: 10px
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f2 .el-form-item__label {
    display: none
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f2 .el-form-item__content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin: 13px auto
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f2 .el-form-item__content .el-select {
    width: 100%;
    box-sizing: border-box
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f2 .el-form-item__content .el-select .el-input {
    width: 100%;
    box-sizing: border-box
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f2 .el-form-item__content .el-select .el-input .el-input__inner {
    width: 100%;
    padding-left: 24px;
    border: none;
    background-color: #f0f2f9;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f2 .el-form-item__content .el-select .el-input .el-input__suffix {
    top: 0px
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f2 .el-form-item__content .el-select .el-input .el-select__caret {
    font-size: 16px;
    color: #464c5f
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f6,
.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f7,
.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f8 {
    width: 100%;
    max-width: 297px;
    height: 66px;
    margin-right: 0px;
    margin-bottom: 39px;
    box-sizing: border-box;
    background-color: #f0f2f9;
    border-radius: 10px
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__label,
.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f7 .el-form-item__label,
.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f8 .el-form-item__label {
    display: none
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__content,
.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f7 .el-form-item__content,
.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f8 .el-form-item__content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin: 13px auto
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__content .el-input,
.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f7 .el-form-item__content .el-input,
.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f8 .el-form-item__content .el-input {
    width: 100%;
    box-sizing: border-box
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f6 .el-form-item__content .el-input .el-input__inner,
.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f7 .el-form-item__content .el-input .el-input__inner,
.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f8 .el-form-item__content .el-input .el-input__inner {
    width: 100%;
    padding-left: 24px;
    border: none;
    background-color: #f0f2f9;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f6.show-time,
.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f7.show-time,
.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f8.show-time {
    max-width: 462px;
    margin-right: 24px
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f6,
.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f7 {
    margin-right: 28px
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f6 .el-input__inner,
.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.f7 .el-input__inner {
    cursor: pointer
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.act .el-form-item__label {
    display: inline-block;
    margin-top: 8px;
    padding-left: 24px;
    font-family: 'Poppins-Medium';
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: 0px;
    color: rgba(17, 24, 46, 0.2)
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.act .el-form-item__content {
    margin: 0 auto
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.act .el-form-item__content .el-select .el-input .el-input__suffix {
    top: -6px
}

.account .tab-cont .unform-box .form-right .demo-form-inline .el-form-item.act .el-form-item__content .el-input .el-input__suffix {
    top: -6px
}

.account .tab-cont .unlink-box {
    margin-top: 40px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
}

.account .tab-cont .unlink-box .link-box-left {
    width: 256px;
    font-family: "Poppins-Bold";
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .unlink-box .link-box-right {
    width: calc(100% - 256px);
    max-width: 950px
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item {
    width: 100%;
    height: 66px;
    margin-right: 0px;
    margin-bottom: 39px;
    box-sizing: border-box;
    background-color: #f0f2f9;
    border-radius: 10px
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item .el-form-item__label {
    display: none
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item .el-form-item__content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin: 13px auto
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item .el-form-item__content .el-input {
    width: 100%;
    box-sizing: border-box
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item .el-form-item__content .el-input .el-input__inner {
    width: 100%;
    padding-left: 24px;
    border: none;
    background-color: #f0f2f9;
    border-radius: 10px;
    font-family: 'Poppins-Medium';
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item:nth-of-type(2) {
    background: transparent
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item:nth-of-type(2) .el-form-item__content {
    margin: 0
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item:nth-of-type(2) .el-form-item__content .copy-link-btn {
    width: 100%;
    max-width: 245px;
    height: 66px;
    display: inline-blocks;
    outline: none;
    border: none;
    background-color: #276dfd;
    border-radius: 10px;
    font-family: "Poppins-Medium";
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 66px;
    letter-spacing: 0px;
    color: #ffffff;
    cursor: pointer
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item:nth-of-type(3) {
    width: 100%;
    min-height: 124px;
    padding: 24px 24px
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item:nth-of-type(3) .el-form-item__content {
    margin: 0
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item:nth-of-type(3) .el-form-item__content .item-title {
    font-family: "Poppins-Bold";
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 33px;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item:nth-of-type(3) .el-form-item__content .item-main {
    margin-top: 19px;
    padding-left: 28px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item:nth-of-type(3) .el-form-item__content .item-main::before {
    content: '';
    width: 8px;
    height: 8px;
    background-color: #276dfd;
    border-radius: 2px;
    position: relative;
    top: 8px;
    left: -28px
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item:nth-of-type(3) .el-form-item__content .item-main .mark {
    margin-right: 8px;
    padding: 0 13px;
    background-color: rgba(39, 109, 253, 0.1);
    border-radius: 4px;
    font-family: "Poppins-Medium";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 23px;
    letter-spacing: 0px;
    color: rgba(17, 24, 46, 0.6)
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item:nth-of-type(3) .el-form-item__content .item-main .name {
    margin-left: 8px;
    font-family: "Poppins-Medium";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 23px;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item.act .el-form-item__label {
    display: inline-block;
    margin-top: 8px;
    padding-left: 24px;
    font-family: 'Poppins-Medium';
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: 0px;
    color: rgba(17, 24, 46, 0.2)
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item.act .el-form-item__content {
    margin: 0 auto
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item.act .el-form-item__content .el-select .el-input .el-input__suffix {
    top: -6px
}

.account .tab-cont .unlink-box .link-box-right .link-form-inline .el-form-item.act .el-form-item__content .el-input .el-input__suffix {
    top: -6px
}

.account .tab-cont .info-box {
    margin-top: 40px;
    width: 100%;
    display: flex;
    justify-content: flex-start
}

.account .tab-cont .info-box .info-box-left {
    width: 256px;
    font-family: "Poppins-Bold";
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .info-box .info-box-right {
    width: calc(100% - 256px);
    max-width: 902px;
    padding: 32px 24px;
    background-color: #f0f2f9;
    border-radius: 10px
}

.account .tab-cont .info-box .info-box-right table {
    width: 100%
}

.account .tab-cont .info-box .info-box-right table thead {
    width: 100%
}

.account .tab-cont .info-box .info-box-right table thead tr {
    width: 100%;
    background-color: rgba(39, 109, 253, 0.1);
    border-radius: 4px
}

.account .tab-cont .info-box .info-box-right table thead tr th {
    padding: 17px 0;
    font-family: "Poppins-Bold";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    text-align: left;
    letter-spacing: 0px;
    color: #11182e
}

.account .tab-cont .info-box .info-box-right table thead tr th:first-of-type {
    width: 25%;
    max-width: 200px;
    padding-left: 40px
}

.account .tab-cont .info-box .info-box-right table tbody {
    width: 100%
}

.account .tab-cont .info-box .info-box-right table tbody tr {
    width: 100%
}

.account .tab-cont .info-box .info-box-right table tbody tr:first-of-type td {
    padding-top: 24px
}

.account .tab-cont .info-box .info-box-right table tbody tr td {
    padding: 12px 0;
    font-family: "Poppins-Medium";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #11182e;
    text-align: left;
    word-wrap: break-word;
    word-break: break-all
}

.account .tab-cont .info-box .info-box-right table tbody tr td:first-of-type {
    width: 20%;
    max-width: 180px;
    padding-left: 40px;
    vertical-align: text-top
}

.resproxy-content {
    display: none
}

@media screen and (max-width: 1200px) {
    .resproxy .tab-cont .tab-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center
    }

    .resproxy .tab-cont .tab-box .title-box {
        width: calc(100% - 80px)
    }

    .resproxy .tab-cont .tab-box .title-box:last-of-type {
        margin-top: 20px
    }

    .resproxy .tab-cont .form-box {
        flex-direction: column
    }

    .resproxy .tab-cont .form-box .form-left {
        margin-bottom: 40px
    }

    .resproxy .tab-cont .form-box .form-right {
        width: 100%
    }

    .resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item:nth-of-type(3),
    .resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item:nth-of-type(4) {
        width: auto
    }

    .resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item:nth-of-type(5) {
        width: auto
    }

    .resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item:nth-of-type(6) {
        min-height: 66px;
        height: auto
    }
}

@media screen and (max-width: 1200px) and (max-width: 650px) {
    .resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item:nth-of-type(6) .el-form-item__content {
        flex-direction: column
    }

    .resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item:nth-of-type(6) .el-form-item__content .helps {
        top: 15px
    }
}

@media screen and (max-width: 1200px) {
    .resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item:nth-of-type(6) .el-form-item__content .helps {
        top: 15px
    }

    .resproxy .tab-cont .link-box {
        flex-direction: column
    }

    .resproxy .tab-cont .link-box .link-box-left {
        margin-bottom: 40px
    }

    .resproxy .tab-cont .link-box .link-box-right {
        width: 100%
    }

    .resproxy .tab-cont .link-box .link-box-right .link-form .link-form-item:first-of-type .api_input {
        width: calc(100% - 25px)
    }

    .resproxy .tab-cont .link-box .link-box-right .link-form .link-form-item:nth-of-type(2) {
        height: auto
    }
}

@media screen and (max-width: 1200px) and (max-width: 700px) {
    .resproxy .tab-cont .link-box .link-box-right .link-form .link-form-item:nth-of-type(2) .copy-link-btn {
        margin-top: 15px
    }
}

@media screen and (max-width: 1200px) {
    .resproxy .tab-cont .example-box {
        flex-direction: column
    }

    .resproxy .tab-cont .example-box .example-box-left {
        margin-bottom: 40px
    }

    .resproxy .tab-cont .example-box .example-box-right {
        width: 100%
    }

    .resproxy .tab-cont .example-box .example-box-right .example-info .example-par .example-par-content .example-par-item {
        margin-bottom: 0px
    }

    .resproxy .tab-cont .example-box .example-box-right .example-info .example-par .example-par-content .example-par-item .example-par-list {
        margin-bottom: 25px
    }

    .account .tab-cont .tab-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center
    }

    .account .tab-cont .tab-box .title-box {
        width: calc(100% - 80px)
    }

    .account .tab-cont .tab-box .title-box:last-of-type {
        margin-top: 20px
    }

    .account .tab-cont .form-box {
        flex-direction: column
    }

    .account .tab-cont .form-box .form-left {
        margin-bottom: 40px
    }

    .account .tab-cont .form-box .form-right {
        width: 100%
    }

    .account .tab-cont .link-box {
        flex-direction: column
    }

    .account .tab-cont .link-box .link-box-left {
        margin-bottom: 40px
    }

    .account .tab-cont .link-box .link-box-right {
        width: 100%
    }

    .account .tab-cont .unform-box {
        flex-direction: column
    }

    .account .tab-cont .unform-box .form-left {
        margin-bottom: 40px
    }

    .account .tab-cont .unform-box .form-right {
        width: 100%
    }

    .account .tab-cont .unlink-box {
        flex-direction: column
    }

    .account .tab-cont .unlink-box .link-box-left {
        margin-bottom: 40px
    }

    .account .tab-cont .unlink-box .link-box-right {
        width: 100%
    }

    .account .tab-cont .info-box {
        flex-direction: column
    }

    .account .tab-cont .info-box .info-box-left {
        margin-bottom: 40px
    }

    .account .tab-cont .info-box .info-box-right {
        width: calc(100% - 60px)
    }
}

@media screen and (max-width: 960px) {
    .resproxy .tab-cont .tab-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center
    }

    .resproxy .tab-cont .tab-box .title-box {
        width: 100%
    }

    .resproxy .tab-cont .tab-box .title-box .title-box-left .title-box-left-main .title-box-left-tip span {
        display: inline-block;
        word-wrap: break-word;
        word-break: break-all
    }

    .resproxy .tab-cont .tab-box .title-box:last-of-type {
        margin-top: 20px
    }

    .resproxy .tab-cont .form-box {
        flex-direction: column
    }

    .resproxy .tab-cont .form-box .form-left {
        width: auto;
        max-width: 256px
    }
}

@media screen and (max-width: 960px) and (max-width: 500px) {
    .resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item {
        margin-right: 0px
    }

    .resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item:nth-of-type(3),
    .resproxy .tab-cont .form-box .form-right .demo-form-inline .el-form-item:nth-of-type(4) {
        margin-right: 0px
    }
}

@media screen and (max-width: 960px) and (max-width: 500px) {
    .resproxy .tab-cont .form-box .form-right .demo-form-inline.demo-unform-inline .el-form-item .el-form-item {
        margin-right: 0px
    }
}

@media screen and (max-width: 960px) {
    .resproxy .tab-cont .link-box {
        flex-direction: column
    }

    .resproxy .tab-cont .link-box .link-box-left {
        width: auto;
        max-width: 256px
    }

    .resproxy .tab-cont .link-box .link-box-right .link-info {
        width: calc(100% - 24px);
        padding: 24px 12px
    }

    .resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content .link-info-item {
        flex-direction: column
    }

    .resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content .link-info-item .link-info-list .mark {
        width: auto;
        max-width: 100px
    }

    .resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content .link-info-item .link-info-list .name {
        width: 100%;
        max-width: 100%
    }
}

@media screen and (max-width: 960px) and (max-width: 500px) {
    .resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content .link-info-item {
        flex-direction: column
    }

    .resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content .link-info-item .link-info-list {
        flex-direction: column;
        padding: 0
    }

    .resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content .link-info-item .link-info-list::before {
        display: none
    }

    .resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content .link-info-item .link-info-list .mark {
        width: auto;
        max-width: 100px;
        margin-right: 0px
    }

    .resproxy .tab-cont .link-box .link-box-right .link-info .link-info-content .link-info-item .link-info-list .name {
        width: 100%;
        max-width: 100%
    }
}

@media screen and (max-width: 960px) {
    .resproxy .tab-cont .example-box {
        flex-direction: column
    }

    .resproxy .tab-cont .example-box .example-box-left {
        width: auto;
        max-width: 256px
    }

    .resproxy .tab-cont .example-box .example-box-right .example-info .example-par .example-par-content .example-par-item {
        flex-direction: column
    }

    .resproxy .tab-cont .example-box .example-box-right .example-info .example-par .example-par-content .example-par-item .example-par-list .mark {
        width: auto;
        max-width: 100px
    }
}

@media screen and (max-width: 960px) and (max-width: 500px) {
    .resproxy .tab-cont .example-box .example-box-right .example-info .example-par .example-par-content .example-par-item .example-par-list {
        flex-direction: column
    }

    .resproxy .tab-cont .example-box .example-box-right .example-info .example-par .example-par-content .example-par-item .example-par-list .mark {
        width: auto;
        max-width: 100px
    }
}

@media screen and (max-width: 960px) {
    .account .tab-cont .form-box {
        flex-direction: column
    }

    .account .tab-cont .form-box .form-left {
        width: auto;
        max-width: 256px
    }

    .account .tab-cont .form-box .form-right .demo-form-inline .el-form-item:nth-of-type(5) .el-form-item__content {
        text-align: center
    }

    .account .tab-cont .form-box .form-right .demo-form-inline .el-form-item:nth-of-type(5) .el-form-item__content .to_cjzzh {
        margin-left: 0
    }
}

@media screen and (max-width: 960px) and (max-width: 500px) {
    .account .tab-cont .form-box .form-right .demo-form-inline .el-form-item {
        margin-right: 0px
    }
}

@media screen and (max-width: 960px) {
    .account .tab-cont .link-box {
        flex-direction: column
    }

    .account .tab-cont .link-box .link-box-left {
        width: auto;
        max-width: 256px
    }

    .account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item:nth-of-type(3) .el-form-item__content .item-main {
        padding-left: 0px
    }

    .account .tab-cont .link-box .link-box-right .link-form-inline .el-form-item:nth-of-type(3) .el-form-item__content .item-main::before {
        display: none
    }

    .account .tab-cont .unform-box {
        flex-direction: column
    }

    .account .tab-cont .unform-box .form-left {
        width: auto;
        max-width: 256px
    }

    .account .tab-cont .unlink-box {
        flex-direction: column
    }

    .account .tab-cont .unlink-box .link-box-left {
        width: auto;
        max-width: 256px
    }

    .account .tab-cont .info-box {
        flex-direction: column
    }

    .account .tab-cont .info-box .info-box-left {
        width: auto;
        max-width: 256px
    }

    .account .tab-cont .info-box .info-box-right {
        width: 100%;
        padding: 32px 0px
    }

    .account .tab-cont .info-box .info-box-right table thead tr th {
        word-wrap: break-word
    }

    .account .tab-cont .info-box .info-box-right table thead tr th:first-of-type {
        padding-left: 0px
    }

    .account .tab-cont .info-box .info-box-right table tbody tr:first-of-type td {
        padding-left: 0px
    }

    .account .tab-cont .info-box .info-box-right table tbody tr td {
        word-wrap: break-word
    }

    .account .tab-cont .info-box .info-box-right table tbody tr td:first-of-type {
        padding-left: 0px
    }

    .resproxy .resproxy-content {
        display: block;
        width: 100%;
        height: 100%;
        padding: 0 .15rem
    }

    .resproxy .resproxy-content .top-nav {
        width: 100%;
        display: flex;
        justify-content: space-between
    }

    .resproxy .resproxy-content .top-nav .top-nav-box2 {
        width: 1.65rem;
        box-shadow: 0 0 0.07rem 0 rgba(0, 0, 0, 0.19);
        border-radius: 0.03rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 0.15rem 0.11rem 0.1rem 0.07rem
    }

    .resproxy .resproxy-content .top-nav .top-nav-box2 .top-nav-box2-top {
        margin-bottom: .1rem;
        display: flex
    }

    .resproxy .resproxy-content .top-nav .top-nav-box2 .top-nav-box2-top .top-nav-box2-top-icon {
        padding-top: .05rem;
        margin-right: 0.1rem
    }

    .resproxy .resproxy-content .top-nav .top-nav-box2 .top-nav-box2-top .top-nav-box2-top-icon img {
        width: .24rem;
        height: .24rem
    }

    .resproxy .resproxy-content .top-nav .top-nav-box2 .top-nav-box2-top .top-nav-box2-top-text {
        font-size: .12rem;
        font-weight: 800;
        color: #233367
    }

    .resproxy .resproxy-content .top-nav .top-nav-box2 .top-nav-box2-top .date {
        font-weight: 400
    }

    .resproxy .resproxy-content .top-nav .top-nav-box2 .top-nav-box-btn {
        width: 1.27rem;
        height: .25rem;
        line-height: .25rem;
        text-align: center;
        background: #d4e2ff;
        border-radius: .03rem;
        color: #276DFD;
        margin-left: .12rem
    }

    .resproxy .resproxy-content .top-nav .active {
        background: #223265
    }

    .resproxy .resproxy-content .top-nav .active p {
        color: #FFFFFF
    }

    .resproxy .resproxy-content .top-nav .active a.top-nav-box-btn {
        color: #FFFFFF;
        background: #276DFD
    }

    .resproxy .resproxy-content .Proxyfrom-box {
        margin-top: .15rem;
        width: 100%
    }

    .resproxy .resproxy-content .Proxyfrom-box .el-input__icon {
        height: auto;
        margin-top: -0.2rem
    }

    .resproxy .resproxy-content .Proxyfrom-box .title {
        margin-bottom: .1rem;
        font-size: .13rem;
        font-weight: 800;
        color: #000000
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .el-form-item {
        width: 1.65rem;
        height: .50rem;
        background: #F0F2F9;
        border-radius: .05rem;
        margin: 0;
        margin-bottom: .20rem;
        padding-left: .1rem
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .el-form-item .el-form-item__label {
        font-size: .1rem;
        font-weight: 500;
        color: #223265;
        opacity: 0.5;
        line-height: .12rem;
        margin-top: 0.07rem
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .el-form-item .el-form-item__content {
        display: block;
        position: relative;
        line-height: .12rem;
        height: .2rem
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .el-form-item .el-form-item__content .el-select {
        width: 100%
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .el-form-item .el-form-item__content .sjt {
        width: .35rem;
        height: 50%;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        right: 0px;
        top: -0rem;
        cursor: pointer
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .el-form-item .el-form-item__content .sjt .el-input__icon {
        height: auto;
        line-height: .12rem
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .el-form-item .el-form-item__content .sjt .el-icon-arrow-up:before {
        line-height: .12rem
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .el-form-item .el-form-item__content .xjt {
        width: .35rem;
        height: 50%;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        right: 0px;
        bottom: -.07rem;
        cursor: pointer
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .el-form-item .el-form-item__content .xjt .el-input__icon {
        height: auto;
        line-height: .12rem
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .el-form-item .el-form-item__content .xjt .el-icon-arrow-up:before {
        line-height: .12rem
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .el-form-item .el-form-item__content .generateApi {
        width: 1.29rem;
        height: .40rem;
        background: #276DFD;
        border-radius: .05rem;
        font-size: .12rem;
        font-weight: 800;
        color: #FFFFFF;
        border: none;
        outline: none
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .el-form-item .el-form-item__content .el-input__inner {
        background-position: 0px center !important;
        height: .2rem;
        background-color: transparent;
        border: none;
        outline: none;
        padding: 0;
        margin-top: .05rem;
        width: 100%
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .el-form-item.wap .el-form-item__content .el-input {
        width: 100%;
        box-sizing: border-box
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .el-form-item.wap .el-form-item__content .el-input .el-input__inner {
        width: 100%;
        padding-left: 24px;
        border: none;
        background-color: #f0f2f9;
        border-radius: 10px;
        font-family: 'Poppins-Medium';
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #11182e;
        background: url("@/assets/index/img/ucenter/api/area/t_qq.png") no-repeat;
        background-size: 15px 15px
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .generateApip {
        background-color: transparent;
        width: 100%;
        display: flex;
        justify-content: flex-end
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .generateApip .el-form-item__content {
        width: 1.29rem;
        margin-right: .3rem;
        position: relative
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .generateApip .helps {
        width: .13rem;
        position: absolute;
        right: -.2rem;
        top: 0
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .generateApip .helps img {
        width: .13rem
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .generateApip .helps .txt {
        display: none;
        position: absolute;
        width: 3.1rem;
        right: 0;
        top: -.48rem;
        background-color: #e8eaef;
        border-radius: .06rem;
        font-size: .12rem;
        line-height: .21rem;
        color: #223265;
        padding-left: .2rem
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .generateApip .helps:hover .txt {
        display: block
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .lastfrom {
        width: 100%
    }

    .resproxy .resproxy-content .Proxyfrom-box .Proxyfrom-inp .el-form .lastfrom .el-select {
        width: 100%
    }

    .resproxy .resproxy-content .Proxyfrom-box .link-box-right .link-form .link-form-item {
        margin-top: 0.1rem
    }

    .resproxy .resproxy-content .Proxyfrom-box .link-box-right .link-form .link-form-item input {
        width: 3.45rem;
        height: .5rem;
        background: #F0F2F9;
        border-radius: .05rem;
        border: none;
        outline: none;
        padding-left: 0.1rem;
        font-size: .12rem
    }

    .resproxy .resproxy-content .Proxyfrom-box .link-box-right .link-form .link-form-item2 {
        display: flex;
        justify-content: flex-end
    }

    .resproxy .resproxy-content .Proxyfrom-box .link-box-right .link-form .link-form-item2 button {
        width: 1.30rem;
        height: .40rem;
        border-radius: .05rem;
        border: none;
        outline: none
    }

    .resproxy .resproxy-content .Proxyfrom-box .link-box-right .link-form .link-form-item2 .open-link-btn {
        background: #276DFD;
        margin-right: 0.1rem;
        color: #ffffff
    }

    .resproxy .resproxy-content .Proxyfrom-box .link-box-right .link-form .link-form-item2 .copy-link-btn {
        background-color: #d4e2ff;
        color: #276DFD
    }

    .resproxy .resproxy-content .link-info-wap {
        width: 3.44rem;
        background: #F0F2F9;
        border-radius: .05rem;
        margin-top: .2rem;
        padding: .15rem .1rem .13rem;
        font-size: .12rem
    }

    .resproxy .resproxy-content .link-info-wap .link-info-title {
        margin-bottom: .15rem;
        font-size: .13rem;
        font-weight: 800;
        color: #000000
    }

    .resproxy .resproxy-content .link-info-wap .link-info-item {
        display: flex;
        justify-content: space-between;
        align-items: center
    }

    .resproxy .resproxy-content .link-info-wap .link-info-item .link-info-list {
        margin-bottom: .12rem;
        display: flex;
        justify-content: flex-start;
        align-items: center
    }

    .resproxy .resproxy-content .link-info-wap .link-info-item .link-info-list .mark {
        height: .15rem;
        background: #DCE4FA;
        margin-right: .06rem;
        padding: 0 .05rem
    }

    .resproxy .resproxy-content .link-info-wap .link-info-item .link-info-list::before {
        content: '';
        width: .08rem;
        height: .08rem;
        background-color: #276dfd;
        border-radius: .02rem;
        margin-right: .05rem
    }

    .resproxy .resproxy-content .example-box-wap {
        margin-top: .2rem;
        padding-top: .08rem
    }

    .resproxy .resproxy-content .example-box-wap .title {
        font-size: .13rem;
        font-weight: 800;
        color: #000000;
        margin-bottom: .1rem;
        padding-left: .1rem
    }

    .resproxy .resproxy-content .example-box-wap .example-box-right {
        background-color: #f0f2f9;
        padding: .08rem .21rem .35rem .1rem
    }

    .resproxy .resproxy-content .example-box-wap .example-box-right .example-info .example-data {
        font-size: .12rem;
        font-weight: 500;
        color: #000000;
        margin-bottom: .12rem
    }

    .resproxy .resproxy-content .example-box-wap .example-box-right .example-par .example-par-title {
        margin-top: .12rem;
        margin-bottom: 0.15rem;
        font-size: .13rem;
        font-weight: 800;
        color: #000000
    }

    .resproxy .resproxy-content .example-box-wap .example-box-right .example-par .example-par-item {
        font-size: .12rem;
        display: flex;
        align-items: center;
        margin-bottom: .12rem
    }

    .resproxy .resproxy-content .example-box-wap .example-box-right .example-par .example-par-item .example-par-list {
        display: flex;
        align-items: center
    }

    .resproxy .resproxy-content .example-box-wap .example-box-right .example-par .example-par-item .example-par-list .mark {
        height: 0.15rem;
        background: #DCE4FA;
        margin-right: 0.06rem;
        padding: 0 .05rem
    }

    .resproxy .resproxy-content .example-box-wap .example-box-right .example-par .example-par-item::before {
        content: '';
        width: .08rem;
        height: .08rem;
        background-color: #276dfd;
        border-radius: .02rem;
        margin-right: .05rem
    }

    .resproxy .use-resprox--content {
        width: 100%;
        height: 100%;
        padding: 0 .15rem;
        display: block !important
    }

    .resproxy .use-resprox--content .top-nav {
        width: 100%;
        display: flex;
        justify-content: space-between
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box {
        width: 1.65rem;
        height: 1.06rem;
        box-shadow: 0 0 0.07rem 0 rgba(0, 0, 0, 0.19);
        border-radius: 0.03rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: .15rem 0 .1rem 0
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box p {
        font-size: .12rem;
        font-weight: 800;
        color: #233367
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box a.top-nav-box-btn {
        width: 1.27rem;
        height: .25rem;
        line-height: .25rem;
        text-align: center;
        background: #d4e2ff;
        border-radius: .03rem;
        color: #276DFD;
        font-size: .12rem;
        font-weight: 800;
        color: #233367
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 {
        width: 100%
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-select {
        width: 100%
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-select .top-nav-top-select-ul {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-select .top-nav-top-select-ul .top-nav-select-item {
        padding: 0.04rem 0.07rem;
        border-top: 1px solid #F0F2F9;
        border-left: 1px solid #F0F2F9;
        border-right: 1px solid #F0F2F9;
        background-color: #fff;
        border-radius: .02rem .02rem 0 0;
        cursor: pointer;
        font-size: .06rem;
        font-family: 'Poppins-Bold';
        font-weight: bold;
        color: #223367;
        line-height: 1
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-select .top-nav-top-select-ul .top-nav-select-item:not(:last-of-type) {
        margin-right: 2px
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-select .top-nav-top-select-ul .top-nav-select-item.active {
        border-top: 1px solid #223265;
        border-left: 1px solid #223265;
        border-right: 1px solid #223265;
        background: #223265;
        color: #fff
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-basic-info-box {
        width: 100%;
        border-radius: 0 0 .02rem .02rem;
        background: #223265;
        padding: .1rem .1rem;
        box-sizing: border-box
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-basic-info-box .top-nav-detail-box {
        width: 100%;
        height: 100%;
        border-radius: .02rem;
        display: flex;
        justify-content: space-between;
        align-items: center
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-basic-info-box .top-nav-detail-box .top-nav-detail-box-left {
        line-height: 1
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-basic-info-box .top-nav-detail-box .top-nav-detail-box-left .top-nav-detail-tit {
        font-size: .1rem;
        font-family: 'Poppins-Black';
        font-weight: bold;
        color: #fff
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-basic-info-box .top-nav-detail-box .top-nav-detail-box-left .top-nav-detail-info {
        margin-top: .1rem;
        display: flex;
        justify-content: flex-start;
        align-items: center
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-basic-info-box .top-nav-detail-box .top-nav-detail-box-left .top-nav-detail-info .top-nav-detail-flow {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: .1rem;
        font-family: 'Poppins-Black';
        font-weight: bold;
        color: #fff;
        line-height: 1
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-basic-info-box .top-nav-detail-box .top-nav-detail-box-left .top-nav-detail-info .top-nav-detail-time {
        margin-left: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: .08rem;
        font-family: 'Poppins-Medium';
        font-weight: 400;
        color: #fff;
        line-height: 1
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-basic-info-box .top-nav-detail-box .top-nav-detail-box-left .top-nav-detail-info .top-nav-detail-time .top-nav-detail-time-icon {
        height: .08rem
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-basic-info-box .top-nav-detail-box .top-nav-detail-box-left .top-nav-detail-info .top-nav-detail-time .top-nav-detail-time-icon img {
        height: 100%;
        margin-top: -0.02rem
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-basic-info-box .top-nav-detail-box .top-nav-detail-box-left .top-nav-detail-info .top-nav-detail-time .top-nav-detail-time-box {
        display: flex;
        justify-content: flex-start;
        align-items: center
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-basic-info-box .top-nav-detail-box .top-nav-detail-box-left .top-nav-detail-info .top-nav-detail-time.top-nav-detail-noflow {
        margin-left: 0
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-basic-info-box .top-nav-detail-box .top-nav-detail-box-right .btn {
        width: 0.6rem;
        height: .25rem;
        line-height: .25rem;
        border-radius: .03rem;
        margin-left: .12rem;
        background-color: #276dfd;
        text-align: center;
        cursor: pointer;
        font-family: 'Poppins-SemiBold';
        font-size: .08rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff
    }

    .resproxy .use-resprox--content .top-nav .top-nav-box2 .top-nav-top-basic-info-box .top-nav-detail-box .top-nav-detail-box-right .btn a {
        display: block;
        width: 100%;
        height: 100%;
        text-decoration: none;
        color: #ffffff
    }

    .resproxy .use-resprox--content .top-nav .active {
        background: #223265
    }

    .resproxy .use-resprox--content .top-nav .active p {
        color: #FFFFFF
    }

    .resproxy .use-resprox--content .top-nav .active a.top-nav-box-btn {
        color: #FFFFFF;
        background: #276DFD
    }

    .resproxy .use-resprox--content .use-resprox--from {
        margin-top: .15rem;
        width: 100%
    }

    .resproxy .use-resprox--content .use-resprox--from .title {
        margin-bottom: .1rem;
        font-size: .13rem;
        font-weight: 800;
        color: #000000
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item {
        width: 1.65rem;
        height: 0.5rem;
        background: #F0F2F9;
        border-radius: 0.05rem;
        margin: 0;
        margin-bottom: 0.2rem;
        padding-left: 0.1rem;
        padding-right: 0.1rem;
        font-size: .12rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.inline {
        width: 100%
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.changbox {
        padding: 0
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.changbox .el-form-item__content {
        width: 100%;
        height: 100%;
        border-radius: 0.05rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.changbox .selectBox {
        width: 100%;
        height: 100%;
        font-size: .12rem;
        line-height: 0.5rem;
        text-align: center;
        border-radius: 0.05rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.changbox .selectBox.active {
        background-color: #223265;
        color: #ffffff
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .isp_select_s {
        left: -0.1rem !important
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .isp_select_s .el-select-dropdown__item {
        padding: 0 0.1rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .el-form-item__label {
        font-size: .1rem;
        font-weight: 500;
        color: #223265;
        opacity: 0.5;
        line-height: .12rem;
        margin-top: .07rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .el-form-item__content {
        display: block;
        position: relative;
        line-height: .12rem;
        height: .2rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .el-form-item__content .el-input__inner {
        background-position: 0px center !important;
        height: 0.2rem;
        background-color: transparent;
        border: none;
        outline: none;
        padding: 0;
        margin-top: 0.05rem;
        font-size: .12rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .el-form-item__content .el-input .el-input__inner::-webkit-outer-spin-button,
    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .el-form-item__content .el-input .el-input__inner::-webkit-inner-spin-button {
        -webkit-appearance: none
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .el-form-item__content .el-input .el-input__inner[type="number"] {
        -moz-appearance: textfield
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .el-form-item__content>span {
        line-height: 20px;
        cursor: pointer
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .el-form-item__content>span>.el-input__icon {
        line-height: 20px;
        font-size: 14px;
        color: #26497c
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .el-form-item__content>span:active {
        transform: scale(1.3)
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .el-form-item__content>span:first-of-type {
        display: block;
        width: 0.1rem;
        height: 50%;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        right: 0px;
        top: 0.05rem;
        cursor: pointer
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .el-form-item__content>span:last-of-type {
        display: block;
        width: 0.1rem;
        height: 50%;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        right: 0px;
        bottom: -0.07rem;
        cursor: pointer
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .el-form-item__content .el-select {
        width: 100%
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .el-form-item__content .el-select .el-input {
        font-size: .12rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .el-form-item__content .el-select .el-input .el-input__suffix {
        top: -.1rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item .el-form-item__content .el-select .el-input .el-select__caret {
        width: auto;
        height: auto
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.wap .el-form-item__content .el-input {
        width: 100%;
        box-sizing: border-box
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.wap .el-form-item__content .el-input .el-input__inner {
        width: 100%;
        padding-left: 24px;
        border: none;
        background-color: #f0f2f9;
        border-radius: 10px;
        font-family: 'Poppins-Medium';
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #11182e;
        background: url("@/assets/index/img/ucenter/api/area/t_qq.png") no-repeat;
        background-size: 15px 15px
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.copy .el-input__inner {
        cursor: pointer
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.link-form-input {
        width: 100%;
        display: flex;
        align-items: center
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.link-form-input .el-form-item__content {
        width: 100%;
        display: flex;
        align-items: center
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.link-form-input .el-form-item__content .el-input {
        width: 100%
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.link-form-input .el-form-item__content .el-input .el-input__inner {
        width: 100%;
        margin-top: 0
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.link-form-btn {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        background-color: transparent
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.link-form-btn .el-form-item__content {
        height: 100%
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.link-form-btn .el-form-item__content .copy-link-btn {
        width: 1.30rem;
        height: .40rem;
        background: #276DFD;
        border-radius: .05rem;
        border: none;
        outline: none;
        color: #ffffff
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.from-link {
        background-color: transparent;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 0;
        margin-top: -.2rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.from-link a {
        font-size: .13rem;
        font-weight: bold;
        text-decoration: underline;
        color: #276DFD
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.act.rightmg {
        width: 100%
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.act.numinp {
        width: 100%
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.links {
        width: 100%;
        height: 1.5rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.links .el-form-item__content {
        width: 100%;
        height: 100%;
        padding: 0.05rem 0.05rem 0.05rem 0
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.links .el-form-item__content #links {
        width: 100%;
        height: 100%;
        background-color: transparent;
        border: none;
        outline: none;
        resize: none;
        font-size: .12rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.links .el-form-item__content #links1 {
        width: 100%;
        height: 100%;
        background-color: transparent;
        border: none;
        outline: none;
        resize: none;
        font-size: .12rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.links .el-form-item__content #unlinks {
        width: 100%;
        height: 100%;
        background-color: transparent;
        border: none;
        outline: none;
        resize: none;
        font-size: .12rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.links .el-form-item__content #unlinks1 {
        width: 100%;
        height: 100%;
        background-color: transparent;
        border: none;
        outline: none;
        resize: none;
        font-size: .12rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .btn-c {
        width: 100%;
        display: flex;
        justify-content: flex-end
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .btn-c .el-form-item.btn {
        width: 1.30rem;
        height: .40rem;
        background: #276DFD;
        border-radius: .05rem;
        color: #ffffff;
        padding: 0;
        margin-left: .15rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .btn-c .el-form-item.btn .el-form-item__content {
        width: 100%;
        height: 100%
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .btn-c .el-form-item.btn .el-form-item__content .btn-btn {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        background-color: transparent;
        color: #ffffff;
        font-size: .12rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.link-form-instructions {
        width: 3.45rem;
        height: auto;
        background: #F0F2F9;
        border-radius: .05rem;
        padding: .1rem;
        margin-bottom: .15rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.link-form-instructions .el-form-item__content {
        height: auto
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.link-form-instructions .el-form-item__content .item-title {
        font-size: .12rem;
        font-weight: bold;
        color: #000000;
        margin-bottom: .1rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.link-form-instructions .el-form-item__content .item-main {
        display: flex;
        align-items: center
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.link-form-instructions .el-form-item__content .item-main .mark {
        padding: .05rem .13rem;
        background-color: #dce4fa;
        color: #a8b1cd;
        margin: 0 .05rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.link-form-instructions .el-form-item__content .item-main .name {
        font-size: .12rem
    }

    .resproxy .use-resprox--content .use-resprox--from .el-form .el-form-item.link-form-instructions .el-form-item__content .item-main::before {
        content: '';
        width: .08rem;
        height: .08rem;
        background-color: #276dfd;
        border-radius: .02rem;
        font-weight: 400
    }

    .resproxy .use-resprox--content .use-resprox--from .info-box {
        padding: .05rem .07rem .12rem .09rem;
        width: 3.45rem;
        background-color: #f0f2f9
    }

    .resproxy .use-resprox--content .use-resprox--from .info-box .info-box-right {
        width: 100%
    }

    .resproxy .use-resprox--content .use-resprox--from .info-box .info-box-right table {
        width: 100%;
        font-size: .12rem
    }

    .resproxy .use-resprox--content .use-resprox--from .info-box .info-box-right table thead tr {
        width: 100%;
        background-color: #c8d7fa
    }

    .resproxy .use-resprox--content .use-resprox--from .info-box .info-box-right table thead tr th {
        text-align: left
    }

    .resproxy .use-resprox--content .use-resprox--from .info-box .info-box-right table thead tr th:nth-child(2) {
        width: 2.3rem;
        padding: .04rem 0 .06rem 0.05rem
    }

    .resproxy .use-resprox--content .use-resprox--from .info-box .info-box-right table thead tr th:nth-child(1) {
        width: 0.92rem;
        padding: .04rem 0 .06rem .11rem
    }

    .resproxy .use-resprox--content .use-resprox--from .info-box .info-box-right table tbody {
        width: 100%
    }

    .resproxy .use-resprox--content .use-resprox--from .info-box .info-box-right table tbody tr {
        width: 3.29rem;
        margin-bottom: 0.1rem;
        display: flex;
        justify-content: space-between;
        height: auto
    }

    .resproxy .use-resprox--content .use-resprox--from .info-box .info-box-right table tbody tr td:nth-child(1) {
        width: 1.2rem;
        padding-left: .1rem;
        margin-right: .10rem
    }

    .resproxy .use-resprox--content .use-resprox--from .info-box .info-box-right table tbody tr td:nth-child(2) {
        width: 2.3rem;
        height: auto
    }

    .resproxy .use-resprox--content .use-resprox--from .form-right2 .el-form-item__content .inputbg {
        padding-left: .15rem;
        border: none;
        background-color: transparent;
        font-size: .12rem;
        color: #11182e;
        background: url(@/assets/index/img/ucenter/api/area/t_qq.png) no-repeat;
        background-position: 0rem center;
        background-size: .10rem .10rem
    }
}

.resproxy .tab-cont .useproxy-balance-banner {
    width: 100%;
    margin-bottom: 16px;
}

.resproxy .tab-cont .useproxy-balance-banner .useproxy-top-basic-info-box {
    width: 100%;
    height: auto;
    padding: 0;
    background: transparent;
}

.resproxy .tab-cont .useproxy-balance-banner .useproxy-top-basic-info-box .useproxy-detail-box.title-box {
    width: 100%;
    min-height: 58px;
    padding: 14px 22px;
    box-sizing: border-box;
    background-color: #223265;
    box-shadow: 0px 3px 21px 0px rgba(34,50,101,0.1);
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
    color: #ffffff;
}

.resproxy .tab-cont .useproxy-balance-banner .useproxy-detail-box-left {
    display: flex;
    align-items: center;
    gap: 18px;
    min-width: 0;
}

.resproxy .tab-cont .useproxy-balance-banner .title-box-left-main {
    display: flex;
    align-items: center;
    gap: 18px;
    min-width: 0;
}

.resproxy .tab-cont .useproxy-balance-banner .useproxy-detail-tit {
    flex: 0 0 auto;
    font: normal 18px/26px 'Poppins-Bold';
    color: inherit;
}

.resproxy .tab-cont .useproxy-balance-banner .useproxy-detail-info {
    margin-top: 0;
    display: flex;
    align-items: baseline;
    gap: 12px;
    min-width: 0;
    font: normal 28px/36px 'Poppins-Bold';
    color: inherit;
}

.resproxy .tab-cont .useproxy-balance-banner .useproxy-detail-time {
    margin-left: 0;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font: 12px/18px 'Poppins-Medium';
    color: #e97a05;
    vertical-align: middle;
    white-space: nowrap;
}

.resproxy .tab-cont .useproxy-balance-banner .useproxy-detail-box-right {
    display: flex;
    align-items: center;
}

.resproxy .tab-cont .useproxy-balance-banner .useproxy-detail-box-right .btn {
    width: 104px;
    height: 36px;
    background-color: #276dfd;
    border-radius: 8px;
    font: normal 14px/36px 'Poppins-SemiBold';
    color: #ffffff;
    cursor: pointer;
}

.resproxy .tab-cont .useproxy-balance-banner .useproxy-detail-box-right .btn a {
    display: block;
    width: 100%;
    height: 100%;
    text-align: center;
    text-decoration: none;
    color: inherit;
}

@media (max-width: 900px) {
    .resproxy .tab-cont .useproxy-balance-banner .useproxy-top-basic-info-box .useproxy-detail-box.title-box {
        padding: 14px 16px;
    }

    .resproxy .tab-cont .useproxy-balance-banner .title-box-left-main,
    .resproxy .tab-cont .useproxy-balance-banner .useproxy-detail-info {
        align-items: flex-start;
        flex-direction: column;
        gap: 6px;
    }

    .resproxy .tab-cont .useproxy-balance-banner .useproxy-detail-info {
        font-size: 24px;
        line-height: 32px;
    }

    .resproxy .tab-cont .useproxy-balance-banner .useproxy-detail-time {
        display: flex;
        margin-left: 0;
        margin-top: 8px;
    }
}
</style>
